<template>
  <v-card color="white" v-if="assignments" class="assignments-modern-card oms-list-table-card">
    <v-card-title class="bg-clr">
      <v-layout>
        <v-flex xs12 class="heading" pt-2 pl-3>Job Assignments </v-flex>
        <!-- <v-flex xs2 v-if="this.$props.driverDoc"
          ><receive-driver-doc-popup :tabOrder="tabOrder" @error="errorDoc()"
        /></v-flex> -->

        <v-flex xs2 pl-3>
          <template>
            <div class="text-center">
              <v-menu
                :disabled="
                  profile.jobStatus == 10 || viewOnly == 'view' || noRole
                "
                offset-y
                class="profile-drop"
              >
                <v-btn
                  slot="activator"
                  color="primary"
                  class="communicate-btn assignments-action-btn assignments-action-btn--primary"
                  :disabled="processing"
                  @click="checkCommunication()"
                  :readonly="noRole"
                  v-permissions="'communicate-customer-jobs'"
                  dark
                  >Send Communication</v-btn
                >
                <v-list>
                  <v-list-tile
                    v-if="
                      (profile.jobStatus >= 6 || profile.jobStatus == 2) &&
                      profile.jobStatus != -1
                    "
                    @click="
                      showCommunicate('milestone');
                      calculateDistance();
                    "
                  >
                    <v-list-tile-title>Milestone Updates</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="
                      (profile.jobStatus == 1 ||
                        profile.jobStatus == 3 ||
                        profile.jobStatus == 4 ||
                        profile.jobStatus == 5) &&
                      profile.jobStatus != -1
                    "
                    @click="
                      error =
                        'Kindly attach milestone and update atleast one status'
                    "
                  >
                    <v-list-tile-title>Milestone Updates</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="
                      (profile.jobStatus >= 5 || profile.jobStatus == 2) &&
                      profile.jobStatus != -1
                    "
                    @click="showCommunicate('driver')"
                  >
                    <v-list-tile-title>Driver Updates</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="
                      (profile.jobStatus == 1 ||
                        profile.jobStatus == 3 ||
                        profile.jobStatus == 4) &&
                      profile.jobStatus != -1
                    "
                    @click="error = 'Kindly assign driver'"
                  >
                    <v-list-tile-title>Driver Updates</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="profile.jobStatus == 8"
                    @click="showCommunicate('paymentPending')"
                  >
                    <v-list-tile-title>Payment Pending</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="profile.jobStatus == 9"
                    @click="showCommunicate('paymentDone')"
                  >
                    <v-list-tile-title>Payment Done</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="profile.jobStatus == -1"
                    @click="showCommunicate('cancel')"
                  >
                    <v-list-tile-title>Cancelled</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="profile.jobStatus == 2"
                    @click="
                      showCommunicate('complete');
                      calculateDistance();
                    "
                  >
                    <v-list-tile-title>Completed</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-flex>
        <v-flex
          xs1
          pt-2
          style="padding-left: 20px"
          v-if="profile.lastsentEmail"
        >
          <v-tooltip
            top
            class="milestone"
            content-class="tooltip-op"
            color="orange"
          >
            <template slot="activator">
              <v-icon>visibility</v-icon>
            </template>
            <span class="tooltip"
              >Last email sent - {{ profile.lastsentEmail }}</span
            >
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-card-text class="nospace assignments-table-shell">
      <v-data-table
        id="dataTable"
        class="assignments-modern-table oms-list-table"
        hide-actions
        item-key="assignmentId"
        :headers="modeAwareHeaders"
        style="width: 100%"
        single-expand
        show-expand
        :items="jobAssignments"
      >
        <template slot="items" slot-scope="props">
          <tr
            class="assignment-row"
            :class="{
              'assignment-row--active': isAssignmentExpanded(props.item),
            }"
            style="cursor: pointer"
            @click="toggleAssignment(props)"
          >
            <td v-if="props.item.assignmentType == 'Value Added Service'">
              <span style="color: blue"> {{ props.item.assignmentId }}</span>
            </td>
            <td v-else>
              {{ props.item.assignmentId }}
            </td>

            <td>
              <v-flex
                v-if="
                  props.item.assignmentStatus != 1 &&
                  props.item.assignmentStatus != 3 &&
                  props.item.assignmentStatus != 4 &&
                  props.item.assignmentStatus != 6 &&
                  jobType == 1
                "
              >
                <AssetAssign
                  :assignId="props.item.assignmentId"
                  :assetId="props.item.assetId"
                  :jobStatus="profile.jobStatus"
                  v-if="
                    props.item.assignmentStatus >= 2 &&
                    props.item.assignmentStatus != 7 &&
                    !props.item.assetId &&
                    jobType == 1
                  "
                  :viewOnly="viewOnly"
                  :country="profile.workingCountry"
                />
                <AssetUnassign
                  :assetId="props.item.assetId"
                  :jobStatus="profile.jobStatus"
                  :assignId="props.item.assignmentId"
                  v-if="
                    props.item.assignmentStatus >= 2 &&
                    props.item.assetId &&
                    jobType == 1
                  "
                  :viewOnly="viewOnly"
                />
              </v-flex>
              <v-flex v-else>
                <div>-</div>
              </v-flex>
            </td>
            <td
              v-if="
                props.item.assetId &&
                (props.item.assignmentStatus == 6 ||
                  props.item.assignmentStatus == 3 ||
                  props.item.assignmentStatus == 4)
              "
            >
              <GpsCollectionPopup :assignmentData="props.item" />
            </td>
            <td v-else>-</td>
            <!-- <td><ValueAdded :assignmentDetails="props.item" /></td> -->
            <td>
              <button
                type="button"
                v-permissions="'add-duty'"
                v-if="
                  props.item.assignmentStatus != 1 &&
                  props.item.assignmentStatus != 3 &&
                  props.item.assignmentStatus != 4 &&
                  props.item.assignmentStatus != 6 &&
                  props.item.assignmentStatus != 7 &&
                  props.item.assignmentStatus != -1 &&
                  props.item.assignmentStatus != 8 &&
                  !props.item.hasVasAttached &&
                  props.item.assignmentType == 'Normal'
                "
                @click.stop="openVas(props.item)"
                color="orange darken-3 "
                :disabled="
                  profile.jobStatus === 10 || viewOnly == 'view' || loading
                "
                class="assignments-action-token assignments-action-token--secondary"
              >
                <v-icon small>playlist_add</v-icon>
                Duty Change
              </button>
              <v-tooltip
                v-permissions="'add-duty'"
                top
                class="milestone"
                content-class="tooltip-op"
                color="grey"
                style="border-radius: 5px"
                v-else-if="
                  (props.item.assignmentStatus == 1 &&
                    props.item.assignmentType == 'Normal') ||
                  (props.item.assignmentStatus == 3 &&
                    props.item.assignmentType == 'Normal') ||
                  (props.item.assignmentStatus == 6 &&
                    props.item.assignmentType == 'Normal') ||
                  (props.item.assignmentStatus == 7 &&
                    props.item.assignmentType == 'Normal') ||
                  (props.item.assignmentStatus == 4 &&
                    props.item.assignmentType == 'Normal') ||
                  (props.item.assignmentStatus == 8 &&
                    props.item.assignmentType == 'Normal')
                "
              >
                <template slot="activator">
                  <button
                    type="button"
                    disabled
                    class="assignments-action-token assignments-action-token--secondary"
                  >
                    <v-icon small>playlist_add</v-icon>
                    Duty Change
                  </button></template
                >
                <span class="tooltip" v-if="props.item.assignmentStatus == 1"
                  >Please assign driver to create Duty for this assignment.
                </span>
                <span
                  class="tooltip"
                  v-else-if="props.item.assignmentStatus == 8"
                  >Required {{ getOperatorPriceLabel(jobType) }} Approval from
                  Accounts(finance) team.
                </span>
                <span class="tooltip" v-else
                  >You can not create after the shipment is offloaded for an
                  assignment.
                </span>
              </v-tooltip>
              <span v-else>-</span>
            </td>
            <td>
              <v-flex>
                <div v-if="props.item.transporterData">
                  {{ props.item.transporterData.transporterName || "-" }}
                </div>
                <div v-else>N.A</div>
                <div
                  v-if="
                    !props.item.hasVasAttached &&
                    props.item.assignmentType == 'Normal'
                  "
                >
                  <button
                    type="button"
                    v-permissions="'unassign-driver-jobs'"
                    v-if="
                      (props.item.assignedToTransporter &&
                        !props.item.isGenerated &&
                        props.item.totalAdditionalAmount == 0 &&
                        props.item.assignmentStatus === 1) ||
                      (props.item.assignedToTransporter &&
                        !props.item.isGenerated &&
                        props.item.totalAdditionalAmount == 0 &&
                        props.item.assignmentStatus === 2) ||
                      (props.item.assignedToTransporter &&
                        !props.item.isGenerated &&
                        props.item.totalAdditionalAmount == 0 &&
                        props.item.assignmentStatus === 5)
                    "
                    :disabled="profile.jobStatus === 10 || viewOnly == 'view'"
                    class="track-ass-btn track-ass-btn--danger"
                    @click="openTransporterUnassign(props.item)"
                  >
                    <v-icon small>person_remove</v-icon>
                    Unassign
                  </button>
                </div>
              </v-flex>
            </td>
            <td>
              <v-flex>
                <div class="pl-3">
                  {{ getModeAwareAssignmentStatus(props.item.assignmentStatus) }}
                  <br />

                  <div
                    v-if="
                      !props.item.hasVasAttached &&
                      props.item.assignmentType == 'Normal'
                    "
                  >
                    <button
                      type="button"
                      v-permissions="'unassign-driver-jobs'"
                      v-if="
                        (!props.item.isGenerated &&
                          props.item.totalAdditionalAmount == 0 &&
                          props.item.assignmentStatus === 2) ||
                        (props.item.totalAdditionalAmount == 0 &&
                          !props.item.isGenerated &&
                          props.item.assignmentStatus === 5)
                      "
                      :disabled="profile.jobStatus === 10 || viewOnly == 'view'"
                      class="track-ass-btn track-ass-btn--danger"
                      @click="openDriverUnassign(props.item)"
                    >
                      <v-icon small>person_remove</v-icon>
                      Unassign
                    </button>
                  </div>

                  <JobsProfileDriverAssign
                    v-if="
                      jobType == 1 &&
                      !props.item.isGenerated &&
                      props.item.assignmentStatus === 1
                    "
                    :milestoneId="props.item.milestoneId"
                    :assignmentId="props.item.assignmentId"
                    :assignmentDetail="props.item"
                    :jobStatus="profile.jobStatus"
                    @transporter-success="refresh()"
                    :currency="props.item.customerCurrency"
                    :country="profile.workingCountry"
                    :viewOnly="viewOnly"
                  />
                  <ChangeDriver
                    v-permissions="'change-driver-master'"
                    v-if="checkChangeDriver(props.item)"
                    :milestoneId="props.item.milestoneId"
                    :assignmentId="props.item.assignmentId"
                    :assignmentDetail="props.item"
                    :jobType="jobType"
                    :jobStatus="profile.jobStatus"
                    @transporter-success="refresh()"
                    :currency="props.item.customerCurrency"
                    :country="profile.workingCountry"
                    :viewOnly="viewOnly"
                  />
                  <jobProfileDriverAssignAir
                    v-if="jobType == 2"
                    :milestoneId="props.item.milestoneId"
                    :assignmentDetail="props.item"
                    :jobStatus="profile.jobStatus"
                    :assignmentId="props.item.assignmentId"
                    :country="profile.workingCountry"
                    :currency="props.item.customerCurrency"
                    :viewOnly="viewOnly"
                  />
                  <jobProfileDriverAssignSea
                    v-if="jobType == 3"
                    :assignmentDetail="props.item"
                    :jobStatus="profile.jobStatus"
                    :toShow="driverAssignModal"
                    :milestoneId="props.item.milestoneId"
                    :currency="props.item.customerCurrency"
                    :country="profile.workingCountry"
                    :assignmentId="props.item.assignmentId"
                    :viewOnly="viewOnly"
                  />
                  <!-- <button
                    type="button"
                    v-permissions="'assign-driver-jobs'"
                    v-if="
                      !props.item.isGenerated &&
                        props.item.assignmentStatus === 1
                    "
                    :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                    class="track-ass-btn"
                    @click.stop="openAssignDriver(props.item)"
                  >
                    Assign
                  </button> -->
                </div>
              </v-flex>
            </td>
            <td>
              <v-flex v-if="props.item.driverFirstName">
                <div>
                  {{ getDriverAssignment(props.item) }}
                  <span
                    v-if="
                      props.item.assignmentStatus != -1 &&
                      props.item.assignmentStatus != 4 &&
                      props.item.assignmentStatus != 3
                    "
                  >
                    <!-- ({{ props.item.driverStatus }}) -->
                  </span>
                </div>
              </v-flex>
              <v-flex v-else>
                <div>
                  -
                  <!-- {{ props.item.driverStatus }} -->
                </div>
              </v-flex>
            </td>
            <td>
              <!-- <v-flex v-if="props.item">
                <div v-if="props.item.truckPrefix">
                  {{ props.item.truckPrefix }}-{{ props.item.truckNumber }}
                </div>
                <div v-else>
                  {{ props.item.driverData.truckPrefix }}-{{
                    props.item.driverData.truckNumber
                  }}
                </div>
              </v-flex> -->
              <!-- <v-flex v-if="props.item.truckPrefix">
                  {{ props.item.truckPrefix }}-{{ props.item.truckNumber }}
 </v-flex>
                <v-flex v-else>
                  {{ props.item.driverData.truckPrefix }}-{{
                    props.item.driverData.truckNumber
                  }}
                </v-flex> -->

              <v-flex v-if="props.item.driverData">
                <div v-if="props.item.truckPrefix">
                  {{ props.item.truckPrefix }}
                  <span v-if="props.item.jobType == '1'">-</span>
                  {{ props.item.truckNumber }}
                </div>
                <div v-else>
                  {{ props.item.driverData.truckPrefix }}
                  <span v-if="props.item.jobType == '1'">-</span
                  >{{ props.item.driverData.truckNumber }}
                </div>
              </v-flex>
              <v-flex v-else>
                <div class="pr-2">-</div>
              </v-flex>
            </td>
            <td @click.stop class="assignment-waybill-cell">
              <v-flex style="">
                <div v-if="props.item.wayBillNo">
                  <div class="text-center v-btn v-btn--flat v-btn--router">
                    <!-- USERS -->
                    <v-menu
                      transition="slide-x-transition"
                      offset-y
                      class="profile-drop"
                    >
                      <v-toolbar-side-icon slot="activator">
                        <v-icon>receipt</v-icon>
                      </v-toolbar-side-icon>
                      <v-list>
                        <v-list-tile
                          v-if="workingcountry != 'PAK'"
                          :to="`/assignments/${props.item.assignmentId}/UAE/waybill`"
                          target="_blank"
                          @click="selectActive(26)"
                          :color="
                            index === 26 ? 'orange darken-3' : 'grey darken-3'
                          "
                        >
                          <v-list-tile-title>UAE</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="workingcountry != 'PAK'"
                          :to="`/assignments/${props.item.assignmentId}/UAE/waybill`"
                          target="_blank"
                          @click="selectActive(26)"
                          :color="
                            index === 26 ? 'orange darken-3' : 'grey darken-3'
                          "
                        >
                          <v-list-tile-title>UAE LA</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="workingcountry != 'PAK'"
                          :to="`/assignments/${props.item.assignmentId}/KSA/waybill`"
                          target="_blank"
                          @click="selectActive(26)"
                          :color="
                            index === 26 ? 'orange darken-3' : 'grey darken-3'
                          "
                        >
                          <v-list-tile-title>KSA</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          v-if="workingcountry == 'PAK'"
                          :to="`/assignments/${props.item.assignmentId}/PAK/waybill`"
                          target="_blank"
                          @click="selectActive(26)"
                          :color="
                            index === 26 ? 'orange darken-3' : 'grey darken-3'
                          "
                        >
                          <v-list-tile-title>PAK</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
                <div v-else>-</div>
              </v-flex>
            </td>
            <td @click.stop class="assignment-documents-cell">
              <v-flex>
                <v-menu
                  transition="slide-x-transition"
                  offset-y
                  class="profile-drop"
                >
                  <v-toolbar-side-icon slot="activator">
                    <button
                      class="track-ass-btn track-ass-btn--menu"
                      type="button"
                      title="view"
                    >
                      <v-icon small>more_horiz</v-icon>
                      <span>More</span>
                    </button>
                  </v-toolbar-side-icon>
                  <v-list>
                    <v-list-tile
                      @click="
                        goToProfile(
                          profile.jobId,
                          props.item.assignmentId,
                          props.item._id,
                          viewOnly
                        )
                      "
                      :color="
                        index === 26 ? 'orange darken-3' : 'grey darken-3'
                      "
                    >
                      <v-list-tile-title>Shipment Documents</v-list-tile-title>
                    </v-list-tile>
                    <!-- <v-list-tile
                      v-if="jobType == 1 && props.item.assignmentStatus > 1"
                      :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                      @click="driverpdfDownload(props.item)"
                      :color="
                        index === 26 ? 'orange darken-3' : 'grey darken-3'
                      "
                    >
                      <v-list-tile-title>Driver Documents</v-list-tile-title>
                    </v-list-tile> -->
                    <v-list-tile
                      @click="driverErrorOpen(props.item)"
                      target="_blank"
                      v-if="jobType == 1"
                      :disabled="
                        profile.jobStatus == 10 ||
                        viewOnly == 'view' ||
                        props.item.assignmentStatus == -1
                      "
                      :color="
                        index === 26 ? 'orange darken-3' : 'grey darken-3'
                      "
                    >
                      <v-list-tile-title
                        >Driver Onboarding Form</v-list-tile-title
                      >
                    </v-list-tile>
                    <v-list-tile
                      v-if="jobType == 1"
                      :disabled="
                        profile.jobStatus == 10 ||
                        viewOnly == 'view' ||
                        props.item.assignmentStatus == -1
                      "
                      @click="errorOpen(props.item)"
                      :color="
                        index === 26 ? 'orange darken-3' : 'grey darken-3'
                      "
                    >
                      <v-list-tile-title>Asset Information</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>
            </td>
            <td @click.stop>
              <div v-if="profile.isJobActivatedByScript">N.A.</div>
              <div v-else>
                <v-flex>
                  <!-- <GenerateAdvance
                  :assId="assignID"
                  v-permissions="'generate-advance-jobs'"
                  :viewOnly="viewOnly"
                  :currency="profile.customerCurrency"
                  :invoiceCity="profile.invoicingCity"
                  :invoiceCompany="profile.invoicingCity"
                  :type="'1'"
                  @generateAdvance="closeMessage()"
                  :totalAmount="props.item.paymentAmount"
                  :totalAdvanceAmount="props.item.totalAdvancePaidAmount"
                /> -->
                  <generateAdvancePopup
                    :assignId="props.item._id"
                    :advancePaid="props.item.totalAdvancePaidAmount"
                    :additionalCharges="props.item.totalAdditionalAmount"
                    :viewOnly="viewOnly"
                    :jobCurrency="profile.customerCurrency"
                  />
                </v-flex>
              </div>
            </td>
            <td @click.stop>
              <div v-if="profile.isJobActivatedByScript">N.A.</div>
              <div v-else>
                <v-flex @click="noInternet()">
                  <additionalChargesPopup
                    :isAssign="props.item._id"
                    :viewOnly="viewOnly"
                    :isCustomerReceiptInitiated="
                      props.item.isCustomerReceiptInitiated
                    "
                    :jobCurrency="profile.customerCurrency"
                    :jobSalesInvoice="profile.isSalesInvoiceGenerated"
                    :amountPaidToDriver="props.item.amountPaidToDriver"
                    :assignSalesInvoice="props.item.isSalesInvoiceGenerated"
                  />
                </v-flex>
              </div>
            </td>
          </tr>
        </template>
        <template
          slot="expand"
          slot-scope="props"
          style="width: 100%"
        >
          <div class="assignment-focus-shell">
            <div class="assignment-focus-header">
              <div>
                <span>Assignment</span>
                <strong>{{ props.item.assignmentId }}</strong>
              </div>
              <button
                type="button"
                class="assignment-focus-close"
                @click.stop="closeAssignmentFocus(props)"
              >
                Close
              </button>
            </div>
            <JobsProfileAssignmentDetail
              :detail="props.item"
              v-on:updateAssignment="updateAssignment"
              v-on:refresh-data="updateAssignment"
              :milestoneItemsList="milestoneItemsList"
              :customer="userDetail"
              :statusData="jobData"
              :assetId="props.item.assetId"
              :working="workingcountry"
              :milestoneList="milestoneItems"
              :profile="profile"
              :tabOrder="tabOrder"
              :jobType="jobType"
              :viewOnly="viewOnly"
            />
          </div>
        </template>
      </v-data-table>
      <confirmation-dialog
        :content="`Are you sure to remove transporter from this assignment?`"
        :toShow="confirmationDialog.removeTransporterAssignment"
        :onClose="() => remove()"
        confirmTitle="Unassign"
        :loading="loading"
        :error="error"
        :onConfirm="() => removeTransporterAssignment(this.assignmentData)"
      />
      <confirmation-dialog
        :content="`Are you sure to remove ${
          this.assignmentData.driverData
            ? this.assignmentData.driverData.name
            : ''
        } from this assignment?`"
        :toShow="confirmationDialog.removeDriverAssignment"
        :onClose="removeDriver"
        confirmTitle="Unassign"
        :loading="loading"
        :error="error"
        :onConfirm="() => removeDriverAssignment(this.assignmentData)"
      />
    </v-card-text>
    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
    <!-- COMMUNICATE CUSTOMER DIALOG -->
    <template>
      <v-layout>
        <v-dialog
          v-model="communicateDialog.show"
          persistent
          max-width="50%"
          content-class="send-updates-dialog"
        >
          <v-form ref="form" onsubmit="return false;">
            <v-card class>
              <v-toolbar flat dense class="send-updates-toolbar">
                <v-toolbar-title>Send Updates</v-toolbar-title>
                <v-spacer></v-spacer>
                <small
                  class="error info"
                  v-show="this.communicateDialog.error"
                  >{{ this.communicateDialog.error }}</small
                >
                <small
                  class="success info"
                  v-show="this.communicateDialog.success"
                  >{{ this.communicateDialog.success }}</small
                >
                <v-btn
                  color="primary"
                  class="communicate-btn send-updates-send-btn"
                  v-if="!loading"
                  dark
                  depressed
                  @click.prevent="checkSendCommunication()"
                  >Send</v-btn
                >
                <v-btn
                  class="send-updates-close-btn"
                  @click.prevent="communicateDialog.show = false"
                  icon
                >
                  <v-icon class="heading grey--text text--darken-4"
                    >close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-spacer>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="To"
                          v-model="communicateDialog.to"
                          value="userDetail.email"
                          disabled
                          hide-details
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-combobox
                          multiple
                          v-model="communicateDialog.select"
                          label="CC"
                          :items="items"
                          append-icon
                          chips
                          deletable-chips
                          hide-selected
                          hide-details
                          :persistent-hint="false"
                          class="tag-input"
                          v-on:keyup.17="checkValue"
                          :search-input.sync="search"
                          @keyup.tab="updateTags"
                          @keypress="smartRecipent"
                          @paste="updateTags"
                          @change="checkValue"
                          :rounded="true"
                        >
                        </v-combobox>
                      </v-flex>
                      <v-flex xs12 sm6 md12>
                        <v-text-field
                          label="Type your subject"
                          v-model="communicateDialog.subject"
                          hide-details
                        />
                      </v-flex>
                      <!--DRIVER-UPDATES-ASSIGNED-TEMPLATE-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'driver' &&
                          jobDetails.jobInfo.jobStatus == 5
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            width: 100%;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/truckkinapi/profilePic_10045726.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad" style="padding: 24px 40px">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Mabrook! Your driver for shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                has been
                                <strong style="font-weight: 600"
                                  >Assigned.</strong
                                >
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are the details of the driver :
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--pending send-tracker__step--line-pending"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--pending"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="send-tracker-actions">
                                  <a
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=track'
                                    "
                                    style="
                                      float: left;
                                      margin-bottom: 10px;
                                      margin-right: 6px;
                                      border-radius: 4px;
                                      color: #fff;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: #0f67c9;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                  >
                                    <img
                                      v-bind:href="
                                        this.constants.webAppUrl +
                                        '/#/tracking?jobId=' +
                                        jobDetails.jobInfo.jobId +
                                        '&type=documents'
                                      "
                                      src="https://s3.amazonaws.com/truckkinapi/profilePic_10068463.png"
                                      style="
                                        width: 16px;
                                        margin-right: 9px;
                                        vertical-align: middle;
                                      "
                                    />Track Your Shipment
                                  </a>
                                  <a
                                    class="assignment-document-view-link"
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=documents'
                                    "
                                    style="
                                      border: 2px solid #0f67c9;
                                      float: left;
                                      border-radius: 4px;
                                      color: #0f67c9;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: transparent;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                    >View Documents</a
                                  >
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  {{ getOperatorDetailsLabel(jobType) }}:
                                </h5>

                                <div
                                  v-for="item in assignments"
                                  :key="item.assignmentId"
                                  style="padding: 15px"
                                >
                                  <div class="img-profile">
                                    <img
                                      width="65"
                                      height="65"
                                      v-if="item.driverData"
                                      v-bind:src="
                                        item.driverData.profilePicURL
                                          ? item.driverData.profilePicURL
                                          : 'https://lakewangaryschool.sa.edu.au/wp-content/uploads/2017/11/placeholder-profile-sq.jpg'
                                      "
                                      style="
                                        border-radius: 50%;
                                        margin-right: 20px;
                                        border: 2px solid darkorange;
                                      "
                                    />
                                  </div>
                                  <div
                                    class="details-section"
                                    style="font-size: 14px"
                                  >
                                    <p
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #000;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Assignment Number
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          color: #000;
                                          word-break: break-all;
                                        "
                                        >{{ item.assignmentId }}</span
                                      >
                                    </p>
                                    <p
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #000;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                        >{{ getOperatorLabel(jobType) }}</span
                                      >
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          color: #000;
                                          word-break: break-all;
                                        "
                                        >{{
                                          item.driverFirstName
                                            ? item.driverFirstName +
                                              " " +
                                              item.driverLastName
                                            : getOperatorNotAssignedYetLabel(jobType)
                                        }}</span
                                      >
                                    </p>

                                    <p
                                      v-if="jobType == '1'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #000;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;

                                          display: inline-block;
                                        "
                                      >
                                        Vehicle Number
                                      </span>
                                      <span
                                        >{{
                                          item.driverId
                                            ? item.driverData.truckPrefix
                                            : ""
                                        }}
                                        {{
                                          item.driverId
                                            ? item.driverData.truckNumber
                                            : "N.A."
                                        }}</span
                                      >
                                    </p>
                                    <p
                                      v-if="jobType == '2'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p
                                      v-if="jobType == '3'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p
                                      v-if="jobType == '1'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getUnitTypeLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        getText(
                                          truckTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p
                                      v-if="jobType == '2'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Type
                                      </span>
                                      <span>{{
                                        getText(
                                          AirTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p
                                      v-if="jobType == '3'"
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Type
                                      </span>
                                      <span>{{
                                        getText(
                                          SeaTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p
                                      style="
                                        padding-bottom: 10px;
                                        padding-top: 10px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>
                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--DRIVER-------UPDATES------TEMPLATES-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'driver' &&
                          (jobDetails.jobInfo.jobStatus == 7 ||
                            jobDetails.jobInfo.jobStatus == 8 ||
                            jobDetails.jobInfo.jobStatus == 9 ||
                            jobDetails.jobInfo.jobStatus == 2)
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            width: 100%;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/truckkinapi/profilePic_10014428.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad" style="padding: 24px 40px">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Congratulations! Your consignment with shipment
                                ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                has been
                                <strong style="font-weight: 600"
                                  >offloaded</strong
                                >
                                succesfully.
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are the details of the driver :
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].transit }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.inTransitDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--complete"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].shipment }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.offloadedDate) }}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="send-tracker-actions">
                                  <a
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=track'
                                    "
                                    style="
                                      margin-bottom: 10px;
                                      margin-right: 10px;
                                      float: left;
                                      border-radius: 4px;
                                      color: #fff;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: #0f67c9;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/truckkinapi/profilePic_10068463.png"
                                      style="
                                        width: 16px;
                                        margin-right: 9px;
                                        vertical-align: middle;
                                      "
                                    />Track Your Shipment
                                  </a>
                                  <a
                                    class="assignment-document-view-link"
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=documents'
                                    "
                                    style="
                                      border: 2px solid #0f67c9;
                                      float: left;
                                      border-radius: 4px;
                                      color: #0f67c9;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: transparent;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                    >View Documents</a
                                  >
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  {{ getOperatorDetailsLabel(jobType) }}:
                                </h5>

                                <div
                                  v-for="item in assignments"
                                  :key="item.assignmentId"
                                  style="padding: 15px"
                                >
                                  <div class="img-profile">
                                    <img
                                      width="65"
                                      height="65"
                                      v-if="item.driverData"
                                      v-bind:src="
                                        item.driverData.profilePicURL
                                          ? item.driverData.profilePicURL
                                          : 'https://lakewangaryschool.sa.edu.au/wp-content/uploads/2017/11/placeholder-profile-sq.jpg'
                                      "
                                      style="
                                        border-radius: 50%;
                                        margin-right: 20px;
                                        border: 2px solid darkorange;
                                      "
                                    />
                                  </div>
                                  <div
                                    class="details-section"
                                    style="font-size: 14px"
                                  >
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Assignment Number
                                      </span>
                                      <span
                                        style="color: #ea8328; font-weight: 600"
                                        >{{ item.assignmentId }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getOperatorLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        item.driverFirstName
                                          ? item.driverFirstName +
                                            " " +
                                            item.driverLastName
                                          : getOperatorNotAssignedYetLabel(jobType)
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '1'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Vehicle Number
                                      </span>
                                      <span
                                        >{{
                                          item.driverId
                                            ? item.driverData.truckPrefix
                                            : ""
                                        }}
                                        {{
                                          item.driverId
                                            ? item.driverData.truckNumber
                                            : "N.A."
                                        }}</span
                                      >
                                    </p>
                                    <p v-if="jobType == '2'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '3'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '1'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getUnitTypeLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        getText(
                                          truckTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '2'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Type
                                      </span>
                                      <span>{{
                                        getText(
                                          AirTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '3'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Type
                                      </span>
                                      <span>{{
                                        getText(
                                          SeaTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                          display: inline-block;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>
                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                          display: inline-block;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--DRIVER-------UPDATES---INTRANSIT---TEMPLATES-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'driver' &&
                          jobDetails.jobInfo.jobStatus == 6
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            width: 100%;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/truckkinapi/profilePic_10089047.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad" style="padding: 24px 40px">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Your consignment with shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                has been
                                <strong style="font-weight: 600"
                                  >on the move.</strong
                                >
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are the details of the driver :
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-pending"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].transit }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.inTransitDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--pending"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="send-tracker-actions">
                                  <a
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=track'
                                    "
                                    style="
                                      margin-right: 5px;
                                      float: left;
                                      border-radius: 4px;
                                      color: #fff;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: #0f67c9;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 158px;
                                    "
                                    target="_blank"
                                    >Track Your Shipment</a
                                  >
                                  <a
                                    class="assignment-document-view-link"
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=documents'
                                    "
                                    style="
                                      border: 2px solid #0f67c9;
                                      float: left;
                                      border-radius: 4px;
                                      color: #0f67c9;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: transparent;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 158px;
                                    "
                                    target="_blank"
                                    >View Documents</a
                                  >
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  {{ getOperatorDetailsLabel(jobType) }}:
                                </h5>
                                <div
                                  v-for="item in assignments"
                                  :key="item.assignmentId"
                                  style="padding: 15px"
                                >
                                  <div class="img-profile">
                                    <img
                                      width="65"
                                      height="65"
                                      v-if="item.driverData"
                                      v-bind:src="
                                        item.driverData.profilePicURL
                                          ? item.driverData.profilePicURL
                                          : 'https://lakewangaryschool.sa.edu.au/wp-content/uploads/2017/11/placeholder-profile-sq.jpg'
                                      "
                                      style="
                                        border-radius: 50%;
                                        margin-right: 20px;
                                        border: 2px solid darkorange;
                                      "
                                    />
                                  </div>
                                  <div
                                    class="details-section"
                                    style="font-size: 14px"
                                  >
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Assignment Number
                                      </span>
                                      <span
                                        style="color: #ea8328; font-weight: 600"
                                        >{{ item.assignmentId }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getOperatorLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        item.driverFirstName
                                          ? item.driverFirstName +
                                            " " +
                                            item.driverLastName
                                          : getOperatorNotAssignedYetLabel(jobType)
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '1'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Vehicle Number
                                      </span>
                                      <span
                                        >{{
                                          item.driverId
                                            ? item.driverData.truckPrefix
                                            : ""
                                        }}
                                        {{
                                          item.driverId
                                            ? item.driverData.truckNumber
                                            : "N.A."
                                        }}</span
                                      >
                                    </p>
                                    <p v-if="jobType == '2'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '3'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '1'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getUnitTypeLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        getText(
                                          truckTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '2'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Type
                                      </span>
                                      <span>{{
                                        getText(
                                          AirTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '3'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Type
                                      </span>
                                      <span>{{
                                        getText(
                                          SeaTypes,
                                          jobDetails.jobInfo.truckType
                                        )
                                      }}</span>
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>
                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--MILESTONE-------UPDATES------TEMPLATES-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'milestone' &&
                          (jobDetails.jobInfo.jobStatus == 7 ||
                            jobDetails.jobInfo.jobStatus == 8 ||
                            jobDetails.jobInfo.jobStatus == 9 ||
                            jobDetails.jobInfo.jobStatus == 2)
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            width: 100%;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/trukkin.com/CONSIGNMENT-DELIVERED.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad" style="padding: 24px 40px">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Congratulations! Your consignment with shipment
                                ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                has been
                                <strong style="font-weight: 600"
                                  >offloaded</strong
                                >
                                successfully.
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are your job details.
                              </p>
                              <div style="margin: 15px; margin-left: 0px">
                                <a
                                  v-bind:href="
                                    this.constants.webAppUrl +
                                    '/#/tracking?jobId=' +
                                    jobDetails.jobInfo.jobId
                                  "
                                  style="
                                    border-radius: 4px;
                                    color: #fff;
                                    text-decoration: none;
                                    box-sizing: border-box;
                                    text-align: center;
                                    background-color: #0f67c9;
                                    height: 37px;
                                    display: block;
                                    line-height: 37px;
                                    font-weight: normal;
                                    font-size: 13px;
                                    width: 158px;
                                  "
                                  target="_blank"
                                  >View Proof of Delivery</a
                                >
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].transit }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.inTransitDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--complete"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].shipment }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.offloadedDate) }}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                  margin-bottom: 10px;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  Job details: {{ jobDetails.jobInfo.jobId }}
                                </h5>
                                <div style="padding: 15px">
                                  <div
                                    class="details-section"
                                    style="
                                      font-size: 14px;
                                      width: 100%;
                                      float: left;
                                    "
                                  >
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Job Status
                                      </span>
                                      <span
                                        style="color: #409f52; font-weight: 600"
                                        >Delivered</span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 190px;
                                          float: left;
                                        "
                                        >Number of Assignments</span
                                      >
                                      <span>{{
                                        jobDetails.jobInfo
                                          .numberOfAssignmentsRequired
                                      }}</span>
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Date
                                      </span>
                                      <span
                                        >{{
                                          getDateTime2(
                                            jobDetails.jobInfo.pickupDate
                                          )
                                        }}
                                        {{ jobDetails.jobInfo.pickupTime }}<span
                                          class="details-section__note"
                                          >{{ emailTimeZone }}</span
                                        ></span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  display: inline-block;
                                  margin-bottom: 15px;
                                  margin-top: 15px;
                                "
                              >
                                <div class="half-colm">
                                  <span
                                    style="
                                      color: #252525;
                                      line-height: 20px;
                                      font-weight: 600;
                                      width: 100%px;
                                      display: inline-block;
                                      padding-left: 40px;
                                    "
                                  >
                                    {{ this.journeyDis }}
                                    (approx) |
                                    {{ this.$props.journeyDays }} Days
                                  </span>
                                  <div
                                    style="
                                      width: 100%;
                                      position: relative;
                                      float: left;
                                      margin-top: 20px;
                                    "
                                  >
                                    <span
                                      class="from-to -line"
                                      style="
                                        width: 2px;
                                        background: #0967c9;
                                        float: left;
                                        height: 170px;
                                      "
                                    ></span>
                                    <span
                                      class="from-to"
                                      style="
                                        width: 20px;
                                        height: 20px;
                                        background: #0967c9;
                                        float: left;
                                      "
                                    ></span>
                                    <p
                                      style="
                                        max-width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      {{
                                        getDateTime2(
                                          jobDetails.jobInfo.pickupDate
                                        )
                                      }}
                                      {{ jobDetails.jobInfo.pickupTime }} ({{
                                        emailTimeZone
                                      }})
                                      <br />
                                      <br />
                                      {{ jobDetails.jobInfo.sourceLocation }}
                                    </p>
                                  </div>
                                  <div style="width: 100%; position: relative">
                                    <span
                                      class="from-to"
                                      style="
                                        width: 20px;
                                        height: 20px;
                                        background: #0967c9;
                                        float: left;
                                      "
                                    ></span>
                                    <p
                                      v-if="jobDetails.jobInfo.offloadedDate"
                                      style="
                                        width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      {{
                                        getDateTime3(
                                          jobDetails.jobInfo.offloadedDate
                                        )
                                      }}
                                      ({{ emailTimeZone }})
                                      <br />
                                      <br />
                                      {{
                                        jobDetails.jobInfo.destinationLocation
                                      }}
                                    </p>
                                    <p
                                      v-if="!jobDetails.jobInfo.offloadedDate"
                                      style="
                                        width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      <br />
                                      <br />
                                      {{
                                        jobDetails.jobInfo.destinationLocation
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--MILESTONE-------UPDATES--INTRANSIT----TEMPLATES-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'milestone' &&
                          jobDetails.jobInfo.jobStatus == 6
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            width: 100%;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/truckkinapi/profilePic_10089047.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Your consignment with shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                is
                                <strong style="font-weight: 600">
                                  on the move.
                                </strong>
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are your job details.
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].transit }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.inTransitDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--pending"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="send-tracker-actions">
                                  <a
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=track'
                                    "
                                    style="
                                      float: left;
                                      margin-bottom: 10px;
                                      margin-right: 6px;
                                      border-radius: 4px;
                                      color: #fff;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: #0f67c9;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/truckkinapi/profilePic_10068463.png"
                                      style="
                                        width: 16px;
                                        margin-right: 9px;
                                        vertical-align: middle;
                                      "
                                    />Track Your Shipment
                                  </a>
                                  <a
                                    class="assignment-document-view-link"
                                    v-bind:href="
                                      this.constants.webAppUrl +
                                      '/#/tracking?jobId=' +
                                      jobDetails.jobInfo.jobId +
                                      '&type=documents'
                                    "
                                    style="
                                      border: 2px solid #0f67c9;
                                      float: left;
                                      border-radius: 4px;
                                      color: #0f67c9;
                                      text-decoration: none;
                                      box-sizing: border-box;
                                      text-align: center;
                                      background-color: transparent;
                                      height: 37px;
                                      display: block;
                                      line-height: 37px;
                                      font-weight: normal;
                                      font-size: 13px;
                                      width: 180px;
                                    "
                                    target="_blank"
                                    >View Documents</a
                                  >
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                  margin-bottom: 10px;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  Job details: {{ jobDetails.jobInfo.jobId }}
                                </h5>
                                <div style="padding: 15px">
                                  <div
                                    class="details-section"
                                    style="
                                      font-size: 14px;
                                      width: 100%;
                                      word-break: break-all;
                                    "
                                  >
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Job Status
                                      </span>
                                      <span
                                        style="color: #ea8328; font-weight: 600"
                                        >{{
                                          getJobStatus(
                                            jobDetails.jobInfo.jobStatus
                                          )
                                        }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 190px;
                                          display: inline-block;
                                        "
                                      >
                                        Number of Assignments
                                      </span>
                                      <span>{{
                                        jobDetails.jobInfo
                                          .numberOfAssignmentsRequired
                                      }}</span>
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Loading Date
                                      </span>
                                      <span
                                        >{{
                                          getDateTime2(
                                            jobDetails.jobInfo.pickupDate
                                          )
                                        }}
                                        {{ jobDetails.jobInfo.pickupTime }}<span
                                          class="details-section__note"
                                          >{{ emailTimeZone }}</span
                                        ></span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>
                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  Assignments
                                </h5>
                                <div
                                  v-for="item in assignments"
                                  :key="item.assignmentId"
                                  style="padding: 15px"
                                >
                                  <div
                                    class="details-section"
                                    style="
                                      font-size: 14px;
                                      width: 100%;
                                      word-break: break-all;
                                    "
                                  >
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Assignment Number
                                      </span>
                                      <span
                                        style="color: #ea8328; font-weight: 600"
                                        >{{ item.assignmentId }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Status
                                      </span>
                                      <span
                                        style="color: #ea8328; font-weight: 600"
                                        >{{
                                          getModeAwareAssignmentStatus(
                                            item.assignmentStatus
                                          )
                                        }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        {{ getOperatorLabel(jobType) }}
                                      </span>
                                      <span>{{
                                        item.driverFirstName
                                          ? item.driverFirstName +
                                            " " +
                                            item.driverLastName
                                          : getOperatorNotAssignedYetLabel(jobType)
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '1'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Vehicle Number
                                      </span>
                                      <span
                                        >{{
                                          item.driverId
                                            ? item.driverData.truckPrefix
                                            : ""
                                        }}
                                        {{
                                          item.driverId
                                            ? item.driverData.truckNumber
                                            : "N.A."
                                        }}</span
                                      >
                                    </p>
                                    <p v-if="jobType == '2'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Flight Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p v-if="jobType == '3'">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Container Number
                                      </span>
                                      <span>{{
                                        item.driverId
                                          ? item.driverData.truckNumber
                                          : "N.A."
                                      }}</span>
                                    </p>
                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Comment
                                      </span>
                                      <span
                                        style="
                                          background: #f2f2f2;
                                          padding: 10px;
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-word;
                                        "
                                        >{{
                                          item.currentChecklist
                                            ? item.currentChecklist.comments
                                              ? item.currentChecklist.comments
                                              : "N.A."
                                            : "N.A."
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div style="border: 1.4px solid #e2e2e2;">
                            <h3
                              style="margin: 15px;text-align: center;color: #686868;font-weight: normal;"
                            >
                              Know your shipment
                              status on the go
                            </h3>
                            <div style="margin: 10px auto;width: 230px;">
                              <a
                                href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                style="display: inline-block;"
                              >
                                <img
                                  src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                  alt="apple-store-icons"
                                  style="width: 100px;"
                                />
                              </a>
                              <a
                                href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                style="display: inline-block;"
                              >
                                <img
                                  src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                  alt="play-store-icon"
                                  style="width: 112px;"
                                />
                              </a>
                            </div>
                          </div>
                          <div
                            class="footer"
                            style="padding: 20px 20px;background-color: #041742;padding-bottom: 10px;"
                          >
                            <div>
                              <p
                                style="color:#c0c5d0;text-align:center;margin:0;font-size: 12px;margin-bottom: 20px;padding: 0px 15px;"
                              >
                                Trukkin is a member of National Association of Freight and Logistics (NAFL) and is bound by the
                                Standards Trading Conditions (STC, available at www.nafl.ae) to the extent applicable.
                              </p>
                              <p style="font-size: 12px;color:#c0c5d0;font-weight:500;line-height:22px;word-spacing: 10px;"> <span
                            style="color:#fff;width: 80px;float: left;">Serving: </span> KSA UAE Kuwait Bahrain Oman
                        Jordan Egypt Iraq Lebanon Pakistan</p>
                              <p
                                style="font-size: 12px;color:#c0c5d0;font-weight:500;line-height:22px;"
                              >
                                <span style="color:#fff;width: 80px;float: left;">Contact:</span>
                                <img
                                  src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                  style="width: 32px;vertical-align: middle;margin-right: 5px;top:0px !important"
                                />+971-5636-81471
                                <img
                                  src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                  style="width: 26px;margin-left: 15px;margin-right: 5px;vertical-align: middle;top:0px !important"
                                />+966-9200-04275
                                <img
                                  src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                  style="width: 26px;vertical-align: middle;margin-right: 5px;margin-left: 15px;top:0px !important"
                                />+92-0311-TRUKKIN
                              </p>
                              <p
                                style="font-size:14px;color:#c0c5d0;font-weight:500;line-height:22px;"
                              >
                                <span style="color:#fff;width: 80px;float: left;">Email Us:</span> operations@trukkin.com
                              </p>
                              <p
                                style="font-size:14px;color:#c0c5d0;font-weight:500;line-height:22px;margin-bottom: 0;"
                              >
                                <a
                                  href="https://www.facebook.com/trukkin/"
                                  style="display: inline-block;"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                    style="width: 26px;vertical-align: middle;"
                                  />
                                </a>
                                <a
                                  href="https://www.instagram.com/trukkinhq/"
                                  style="display: inline-block;"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                    style="width: 26px; vertical-align: middle;margin-left: 15px;"
                                  />
                                </a>
                                <a
                                  href="https://twitter.com/TrukkinHQ"
                                  style="display: inline-block;"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                    style="width: 26px;vertical-align: middle;margin-left: 15px;"
                                  />
                                </a>
                                <a
                                  href="https://www.linkedin.com/company/trukkin"
                                  style="display: inline-block;"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/link.png"
                                    style="width: 26px;vertical-align: middle;margin-left: 15px;"
                                  />
                                </a>
                              </p>
                              <div
                                class="botm"
                                style="font-size: 12px;color: #c0c5d0;line-height: 32px;display: inline-block;width: 100%;margin-bottom: 0;"
                              >
                                <div class="bottom">
                                  <a
                                    href="mailto:contact@trukkin.com"
                                    style="text-decoration:none;color: #c0c5d0;"
                                  >Disclaimers</a> |
                                  <a
                                    href="https://trukkin.com/terms-conditions/"
                                    target="_blank"
                                    style="text-decoration:none;color: #c0c5d0;"
                                  >Terms &amp; Conditions</a> |
                                  <a
                                    href="https://trukkin.com/policy/"
                                    target="_blank"
                                    style="text-decoration:none;color: #c0c5d0;"
                                  >Privacy Policy</a>
                                </div>
                                <img
                                  class="verified"
                                  src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                  alt="apple-store-icons"
                                  style="width: 150px;float: right;"
                                />
                              </div>
                            </div>
                          </div>-->
                        </div>
                      </template>
                      <!--CANCEL--JOB--TEMPLATE------------->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'cancel' &&
                          jobDetails.jobInfo.jobStatus == -1
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                            width: 100%;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/trukkin.com/cacellation.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Apologies, we had to cancel your booking with
                                shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                <strong style="font-weight: 600"
                                  >due to unfavourable conditions.</strong
                                >
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Trukkin is eager to serve you for your next
                                shipment requirement.
                              </p>
                              <div
                                style="
                                  margin: 15px;
                                  margin-left: 0;
                                  display: inline-block;
                                "
                              >
                                <a
                                  v-bin-href="'tel:800 TRUKKIN'"
                                  style="
                                    border-radius: 4px;
                                    color: #fff;
                                    text-decoration: none;
                                    box-sizing: border-box;
                                    text-align: center;
                                    background-color: #0f67c9;
                                    height: 37px;
                                    display: block;
                                    line-height: 37px;
                                    font-weight: normal;
                                    font-size: 13px;
                                    width: 108px;
                                    float: left;
                                    margin-right: 10px;
                                  "
                                  target="_blank"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/truckkinapi/profilePic_10010428.png"
                                    style="
                                      width: 22px;
                                      vertical-align: middle;
                                      margin-right: 2px;
                                    "
                                  />Call Us
                                </a>
                                <a
                                  href="mailto:contact@trukkin.com"
                                  style="
                                    border-radius: 4px;
                                    color: #fff;
                                    text-decoration: none;
                                    box-sizing: border-box;
                                    text-align: center;
                                    background-color: #0f67c9;
                                    height: 37px;
                                    display: block;
                                    line-height: 37px;
                                    font-weight: normal;
                                    font-size: 13px;
                                    width: 108px;
                                    float: left;
                                  "
                                  target="_blank"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/truckkinapi/profilePic_10088410.png"
                                    style="
                                      width: 24px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                    "
                                  />Email Us
                                </a>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                  margin-bottom: 10px;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  Job details: {{ jobDetails.jobInfo.jobId }}
                                </h5>
                                <div style="padding: 15px">
                                  <div
                                    class="details-section"
                                    style="
                                      font-size: 14px;
                                      width: 100%;
                                      float: left;
                                    "
                                  >
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Job Status
                                      </span>
                                      <span
                                        style="color: #d83636; font-weight: 600"
                                        >Cancelled</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 190px;
                                          display: inline-block;
                                        "
                                      >
                                        Number of Assignments
                                      </span>
                                      <span>{{
                                        jobDetails.jobInfo
                                          .numberOfAssignmentsRequired
                                      }}</span>
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          display: inline-block;
                                        "
                                      >
                                        Cancelled Date
                                      </span>
                                      <span
                                        >{{ getDateTime3(date) }}<span
                                          class="details-section__note"
                                          >{{ emailTimeZone }}</span
                                        ></span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Cancellation Reason
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.cancellationReason
                                        }}</span
                                      >
                                    </p>
                                    <p>
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>

                                    <p
                                      style="
                                        border-bottom: 1px solid #f2f2f2;
                                        padding-bottom: 20px;
                                      "
                                    >
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--COMPLETE--JOB--TEMPLATE------------->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'complete' &&
                          jobDetails.jobInfo.jobStatus == 2
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                            width: 100%;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/trukkin.com/CONSIGNMENT-DELIVERED.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad" style="padding: 24px 40px">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Congratulations! Your consignment with shipment
                                ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                has been
                                <strong style="font-weight: 600"
                                  >offloaded</strong
                                >
                                successfully.
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here are your job details.
                              </p>
                              <div style="margin: 15px; margin-left: 0">
                                <a
                                  v-bind:href="
                                    this.constants.webAppUrl +
                                    '/#/tracking?jobId=' +
                                    jobDetails.jobInfo.jobId
                                  "
                                  style="
                                    border-radius: 4px;
                                    color: #fff;
                                    text-decoration: none;
                                    box-sizing: border-box;
                                    text-align: center;
                                    background-color: #0f67c9;
                                    height: 37px;
                                    display: block;
                                    line-height: 37px;
                                    font-weight: normal;
                                    font-size: 13px;
                                    width: 158px;
                                  "
                                  target="_blank"
                                  >View Proof of Delivery</a
                                >
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  margin-bottom: 20px;
                                "
                              >
                                <table class="send-tracker">
                                  <tbody>
                                    <tr>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Booking Confirmed
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.newCreatedAt) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          {{ getOperatorAssignedLabel(jobType) }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].Assigned }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.driverAssignedDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--done send-tracker__step--line-done"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          In-Transit
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].transit }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.inTransitDate) }}
                                        </span>
                                      </td>
                                      <td
                                        class="send-tracker__step send-tracker__step--complete"
                                      >
                                        <span class="send-tracker__marker" aria-hidden="true"></span>
                                        <span class="send-tracker__label">
                                          Off-loaded/<wbr />Delivered
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ jobData[0].shipment }} / {{ jobDetails.jobInfo.numberOfAssignmentsRequired }}
                                        </span>
                                        <span class="send-tracker__meta">
                                          {{ getTime4(jobDetails.jobInfo.offloadedDate) }}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                  display: inline-block;
                                  margin-bottom: 10px;
                                "
                              >
                                <h5
                                  style="
                                    padding: 15px;
                                    color: #252525;
                                    font-size: 20px;
                                    text-align: left;
                                    margin: 0;
                                    background: #f8f8f8;
                                  "
                                >
                                  Job details: {{ jobDetails.jobInfo.jobId }}
                                </h5>
                                <div style="padding: 15px">
                                  <div
                                    class="details-section"
                                    style="
                                      font-size: 14px;
                                      width: 100%;
                                      float: left;
                                    "
                                  >
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Job Status
                                      </span>
                                      <span
                                        style="color: #409f52; font-weight: 600"
                                        >Delivered</span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 190px;
                                          float: left;
                                        "
                                      >
                                        Number of Assignments
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo
                                            .numberOfAssignmentsRequired
                                        }}</span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Date
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          getDateTime2(
                                            jobDetails.jobInfo.pickupDate
                                          )
                                        }}
                                        {{ jobDetails.jobInfo.pickupTime }}<span
                                          class="details-section__note"
                                          >{{ emailTimeZone }}</span
                                        ></span
                                      >
                                    </p>
                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span
                                      >
                                    </p>

                                    <p style="margin-bottom: 20px">
                                      <span
                                        style="
                                          color: #252525;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 170px;
                                          float: left;
                                        "
                                      >
                                        Off-loading Location
                                      </span>
                                      <span
                                        style="
                                          display: table;
                                          border-radius: 5px;
                                          word-break: break-all;
                                        "
                                        >{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  display: inline-block;
                                  margin-bottom: 15px;
                                  margin-top: 15px;
                                "
                              >
                                <div class="half-colm">
                                  <span
                                    style="
                                      width: 100%;
                                      color: #252525;
                                      line-height: 20px;
                                      font-weight: 600;
                                      width: 100%px;
                                      display: inline-block;
                                      padding-left: 40px;
                                    "
                                  >
                                    {{ this.journeyDis }}
                                    (approx) |
                                    {{ this.$props.journeyDays }} Days
                                  </span>
                                  <div
                                    style="
                                      width: 100%;
                                      position: relative;
                                      float: left;
                                      margin-top: 20px;
                                    "
                                  >
                                    <span
                                      class="from-to -line"
                                      style="
                                        width: 2px;
                                        background: #0967c9;
                                        float: left;
                                        height: 170px;
                                      "
                                    ></span>
                                    <span
                                      class="from-to"
                                      style="
                                        width: 20px;
                                        height: 20px;
                                        background: #0967c9;
                                        float: left;
                                      "
                                    ></span>
                                    <p
                                      style="
                                        max-width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      {{
                                        getDateTime2(
                                          jobDetails.jobInfo.pickupDate
                                        )
                                      }}
                                      {{ jobDetails.jobInfo.pickupTime }} ({{
                                        emailTimeZone
                                      }})
                                      <br />
                                      <br />
                                      {{ jobDetails.jobInfo.sourceLocation }}
                                    </p>
                                  </div>
                                  <div style="width: 100%; position: relative">
                                    <span
                                      class="from-to"
                                      style="
                                        width: 20px;
                                        height: 20px;
                                        background: #0967c9;
                                        float: left;
                                      "
                                    ></span>
                                    <p
                                      v-if="jobDetails.jobInfo.offloadedDate"
                                      style="
                                        width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      {{
                                        getDateTime3(
                                          jobDetails.jobInfo.offloadedDate
                                        )
                                      }}
                                      ({{ emailTimeZone }})
                                      <br />
                                      <br />
                                      {{
                                        jobDetails.jobInfo.destinationLocation
                                      }}
                                    </p>
                                    <p
                                      v-if="!jobDetails.jobInfo.offloadedDate"
                                      style="
                                        width: 80%;
                                        float: left;
                                        padding-left: 18px;
                                        margin: 0;
                                      "
                                    >
                                      <br />
                                      <br />
                                      {{
                                        jobDetails.jobInfo.destinationLocation
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--PAYMENT-DONE--TEMPLATE-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'paymentDone' &&
                          jobDetails.jobInfo.jobStatus == 9
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                            width: 100%;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/trukkin.com/payment-complete.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                Shukraan! The payment of your consignment with
                                shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                is
                                <strong style="font-weight: 600"
                                  >complete</strong
                                >
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here’s your job and payment break down.
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                "
                              >
                                <table
                                  class="table-body"
                                  style="width: 100%; border-spacing: 0"
                                >
                                  <thead>
                                    <tr
                                      style="
                                        background: #f8f8f8;
                                        line-height: 32px;
                                      "
                                    >
                                      <th
                                        style="
                                          background: #f8f8f8;
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 18px;
                                          text-align: left;
                                        "
                                      >
                                        Details:
                                      </th>
                                      <th style="background: #f8f8f8"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                        "
                                      >
                                        <span>Company Name :</span>
                                      </td>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          userDetail.companyName
                                        }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                        "
                                      >
                                        <span>Company Address :</span>
                                      </td>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{ userDetail.address }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 600;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>From :</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px 15px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 600;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>To :</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px 15px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="table-body" style="width: 100%">
                                  <thead style>
                                    <tr
                                      style="
                                        background: #fafafa;
                                        line-height: 32px;
                                      "
                                    >
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                        "
                                      >
                                        Sr No
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Consignment Details
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                        "
                                      >
                                        Quantity
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                        "
                                      >
                                        Price
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                        "
                                      >
                                        Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>1</span>
                                      </td>
                                      <td
                                        v-if="jobType == '1'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            truckTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        v-if="jobType == '2'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            AirTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        v-if="jobType == '3'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            SeaTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo
                                            .numberOfAssignmentsRequired
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.jobPrice /
                                          jobDetails.jobInfo
                                            .numberOfAssignmentsRequired
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  class="table-body"
                                  style="
                                    width: 100%;
                                    border-top: 1px dashed #333;
                                    border-bottom: 1px dashed #333;
                                    word-break: break-all;
                                  "
                                >
                                  <thead style>
                                    <tr
                                      style="
                                        background: #fafafa;
                                        line-height: 32px;
                                      "
                                    >
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 15px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Sub-Total:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Tax:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span>-</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Adjustments:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span>-</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  class="table-body"
                                  style="width: 100%; word-break: break-all"
                                >
                                  <thead style>
                                    <tr
                                      style="
                                        background: #fafafa;
                                        line-height: 32px;
                                      "
                                    >
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Grand Total:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 100px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <!--PAYMENT-PENDING--TEMPLATE-->
                      <template
                        class="payment-body"
                        v-if="
                          communicateDialog.type == 'paymentPending' &&
                          jobDetails.jobInfo.jobStatus == 8
                        "
                      >
                        <loading :active.sync="loading" />
                        <div
                          style="
                            background: #f57c0026;
                            font-family: Helvetica Neue, Helvetica, Helvetica,
                              sans-serif;
                            letter-spacing: 0.4px;
                            width: 100%;
                          "
                        >
                          <div
                            style="
                              width: 100%;
                              max-width: 600px;
                              height: auto;
                              margin: 15px auto;
                              background: #fff;
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                height: auto;
                                background: #041742;
                                color: #fff;
                                width: 100%;
                                height: 68px;
                              "
                            >
                              <div
                                class="logo"
                                style="float: left; margin-top: 10px"
                              >
                                <img
                                  alt="logo"
                                  src="../../../assets/v_logo_new.png"
                                  style="width: 116px; padding-left: 20px"
                                />
                              </div>
                              <div
                                class="right-text"
                                style="
                                  padding-right: 20px;
                                  font-size: 14px;
                                  float: right;
                                  margin-top: 25px;
                                "
                              >
                                {{ currentDate }}
                              </div>
                            </div>
                            <img
                              src="https://s3.amazonaws.com/trukkin.com/payment-pending.png"
                              style="max-width: 100%"
                            />
                            <div class="main-pad">
                              <p
                                style="
                                  font-size: 25px;
                                  color: #000;
                                  font-weight: 300;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                  font-family: inherit;
                                "
                              >
                                The payment of your consignment with shipment ID
                                <span style="color: #f48122"
                                  >#{{ jobDetails.jobInfo.jobId }}</span
                                >
                                is
                                <strong style="font-weight: 600"
                                  >yet to be complete.</strong
                                >
                              </p>
                              <p
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 300;
                                  line-height: 24px;
                                  margin: 0px;
                                  margin-bottom: 20px;
                                "
                              >
                                Here’s your job and payment break down.
                              </p>
                              <div
                                style="
                                  width: 100%;
                                  text-align: left;
                                  border: 1.4px solid #e2e2e2;
                                "
                              >
                                <table
                                  class="table-body"
                                  style="
                                    width: 100%;
                                    border-spacing: 0;
                                    word-break: break-all;
                                  "
                                >
                                  <thead>
                                    <tr
                                      style="
                                        background: #f8f8f8;
                                        line-height: 32px;
                                      "
                                    >
                                      <th
                                        style="
                                          background: #f8f8f8;
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 18px;
                                          text-align: left;
                                        "
                                      >
                                        Details:
                                      </th>
                                      <th style="background: #f8f8f8"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                        "
                                      >
                                        <span>Company Name :</span>
                                      </td>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          this.$props.userDetail.companyName
                                        }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 600;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>Company Address :</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          this.$props.userDetail.address
                                        }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 600;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>From :</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px 15px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.sourceLocation
                                        }}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          white-space: nowrap;
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 600;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>To :</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 15px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          font-weight: 400;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.destinationLocation
                                        }}</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  class="table-body"
                                  style="width: 100%; border-spacing: 0"
                                >
                                  <thead>
                                    <tr
                                      style="
                                        background: #f8f8f8;
                                        line-height: 32px;
                                      "
                                    >
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Sr No
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Consignment Details
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Quantity
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Price
                                      </th>
                                      <th
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          text-align: left;
                                          line-height: 17px;
                                        "
                                      >
                                        Total
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>1</span>
                                      </td>
                                      <td
                                        v-if="jobType == '1'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            truckTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        v-if="jobType == '2'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            AirTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        v-if="jobType == '3'"
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          line-height: 17px;
                                        "
                                      >
                                        <span>{{
                                          getText(
                                            SeaTypes,
                                            jobDetails.jobInfo.truckType
                                          )
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo
                                            .numberOfAssignmentsRequired
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span>{{
                                          jobDetails.jobInfo.jobPrice /
                                          jobDetails.jobInfo
                                            .numberOfAssignmentsRequired
                                        }}</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  class="table-body"
                                  style="
                                    border-spacing: 0;
                                    width: 100%;
                                    border-top: 1px dashed #333;
                                    border-bottom: 1px dashed #333;
                                    word-break: break-all;
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Sub-Total:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Tax:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span>-</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Adjustments:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 5px 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          width: 100px;
                                        "
                                      >
                                        <span>-</span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  class="table-body"
                                  style="
                                    width: 100%;
                                    word-break: break-all;
                                    border-spacing: 0;
                                  "
                                >
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td></td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 130px;
                                        "
                                      >
                                        <span>Grand Total:</span>
                                      </td>
                                      <td
                                        style="
                                          padding: 10px;
                                          color: #252525;
                                          font-size: 14px;
                                          line-height: 20px;
                                          font-weight: 600;
                                          width: 100px;
                                        "
                                      >
                                        <span
                                          >{{ jobDetails.jobInfo.jobPrice }}
                                          {{
                                            jobDetails.jobInfo.customerCurrency
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div style="border: 1.4px solid #e2e2e2">
                              <h3
                                style="
                                  margin: 15px;
                                  text-align: center;
                                  color: #686868;
                                  font-weight: normal;
                                "
                              >
                                Know your shipment status on the go
                              </h3>
                              <div style="margin: 10px auto; width: 230px">
                                <a
                                  href="https://apps.apple.com/us/app/trukkin/id1227697871"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/apple.png"
                                    alt="apple-store-icons"
                                    style="width: 100px"
                                  />
                                </a>
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.trukkin&hl=en_IN"
                                  style="display: inline-block"
                                >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/play-store.png"
                                    alt="play-store-icon"
                                    style="width: 112px"
                                  />
                                </a>
                              </div>
                            </div>
                            <div
                              class="footer"
                              style="
                                padding: 20px 20px;
                                background-color: #041742;
                                padding-bottom: 10px;
                              "
                            >
                              <div>
                                <p
                                  style="
                                    color: #c0c5d0;
                                    text-align: center;
                                    margin: 0;
                                    font-size: 12px;
                                    margin-bottom: 20px;
                                    padding: 0px 15px;
                                  "
                                >
                                  Trukkin is a member of National Association of
                                  Freight and Logistics (NAFL) and is bound by
                                  the Standards Trading Conditions (STC,
                                  available at www.nafl.ae) to the extent
                                  applicable.
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    word-spacing: 6px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Serving:</span
                                  >
                                  KSA UAE Kuwait Bahrain Oman Jordan Egypt Iraq
                                  Lebanon Pakistan
                                </p>
                                <p
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Contact:</span
                                  >
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-1.png"
                                    style="
                                      width: 32px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      top: 0px !important;
                                    "
                                  />+971-5636-81471
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-2.png"
                                    style="
                                      width: 26px;
                                      margin-left: 15px;
                                      margin-right: 5px;
                                      vertical-align: middle;
                                      top: 0px !important;
                                    "
                                  />+966-9200-04275
                                  <img
                                    src="https://s3.amazonaws.com/trukkin.com/flag-3.png"
                                    style="
                                      width: 26px;
                                      vertical-align: middle;
                                      margin-right: 5px;
                                      margin-left: 15px;
                                      top: 0px !important;
                                    "
                                  />+92-0311-TRUKKIN
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                  "
                                >
                                  <span
                                    style="
                                      color: #fff;
                                      width: 80px;
                                      float: left;
                                    "
                                    >Email Us:</span
                                  >
                                  operations@trukkin.com
                                </p>
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #c0c5d0;
                                    font-weight: 500;
                                    line-height: 22px;
                                    margin-bottom: 0;
                                  "
                                >
                                  <a
                                    href="https://www.facebook.com/trukkin/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/fb.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.instagram.com/trukkinhq/"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/insta.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://twitter.com/TrukkinHQ"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/twt.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                  <a
                                    href="https://www.linkedin.com/company/trukkin"
                                    style="display: inline-block"
                                  >
                                    <img
                                      src="https://s3.amazonaws.com/trukkin.com/link.png"
                                      style="
                                        width: 26px;
                                        vertical-align: middle;
                                        margin-left: 15px;
                                      "
                                    />
                                  </a>
                                </p>
                                <div
                                  class="botm"
                                  style="
                                    font-size: 12px;
                                    color: #c0c5d0;
                                    line-height: 32px;
                                    display: inline-block;
                                    width: 100%;
                                    margin-bottom: 0;
                                  "
                                >
                                  <div class="bottom">
                                    <a
                                      href="mailto:contact@trukkin.com"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Disclaimers</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/terms-conditions/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Terms &amp; Conditions</a
                                    >
                                    |
                                    <a
                                      href="https://trukkin.com/policy/"
                                      target="_blank"
                                      style="
                                        text-decoration: none;
                                        color: #c0c5d0;
                                      "
                                      >Privacy Policy</a
                                    >
                                  </div>
                                  <img
                                    class="verified"
                                    src="https://s3.amazonaws.com/trukkin.com/certified.jpg"
                                    alt="apple-store-icons"
                                    style="width: 150px; float: right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-spacer>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>
    </template>
    <!---Asset-ERROR------->
    <v-dialog
      v-model="dialog6"
      persistent
      :max-width="450"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          style="background-color: #fee9d0; color: black; padding-left: 130px"
          flat
        >
          <v-toolbar-title>{{ errorTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click.prevent="dialog6 = false">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text style="text-align: center" class="pa-4">
            <div class="pb-4">
              <img
                src="../../../assets/Character-jumping.svg"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ errorMessage }}</div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="dialog6 = false"
              :loading="loading"
              text
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
    <!--Driver-Error-Popup-->
    <v-dialog
      v-model="dialog7"
      persistent
      :max-width="450"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          style="background-color: #fee9d0; color: black; padding-left: 130px"
          flat
        >
          <v-toolbar-title>{{ errorTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialog7 = false"
            ></v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text style="text-align: center" class="pa-4">
            <div class="pb-4">
              <img
                src="../../../assets/Illustrations-groovy.svg"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ errorMessage }}</div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="dialog7 = false"
              :loading="loading"
              text
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog8"
      persistent
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel8"
    >
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
          <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>

        <v-card-actions class="pt-0">
          <v-btn
            color="primary darken-1"
            text
            @click.native="this.dialog8 = agree"
            >Yes</v-btn
          >
          <!-- <v-btn color="grey" text @click.native="cancel8">Cancel</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogForVas"
      persistent
      :max-width="650"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #f5f5f5; color: black" flat>
          <v-toolbar-title> Confirmation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialogForVas = false"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text class="pa-4"> {{ vasMessagePopup }} </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              medium
              class="pr-2"
              style="text-transform: none !important"
              darken-1
              :disabled="loading"
              text
              @click="dialogForVas = false"
              >Cancel</v-btn
            >
            <div class="pl-2">
              <ValueAdded
                :assignmentDetails="vasAssignmentData"
                @refresh-list-Vas="refreshListViaVas()"
              />
            </div>
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  StorageKeys,
  TruckTypes,
  AirTypes,
  SeaTypes,
} from "../../../constants/constants";
import JobsProfileAssignmentDetail from "./JobsProfileAssignmentDetail.vue";
import ReceiveDriverDocPopup from "./ReceiveDriverDocPopup";
import GpsCollectionPopup from "./GpsCollectionPopup";
import GenerateAdvance from "@/components/Pop-ups/GenerateAdvance";
import addProofOfDelivery from "@/components/Pop-ups/addProofOfDelivery";
import ConfirmationDialog from "@/components/Common/ConfirmationDialog";
import AssetAssign from "@/components/Pop-ups/AssetAssign";
import AssetUnassign from "@/components/Pop-ups/AssetUnassign";
import AddDocument from "@/components/JobDocuments/AddDocument.vue";
import JobsProfileDriverAssign from "@/components/Jobs/AssignDriver/JobsProfileDriverAssign";
import ValueAdded from "@/components/Jobs/JobDetails/ValueAdded";
import ChangeDriver from "../AssignDriver/ChangeDriver.vue";

import jobProfileDriverAssignAir from "@/components/Jobs/AssignDriver/jobProfileDriverAssignAir";
import jobProfileDriverAssignSea from "@/components/Jobs/AssignDriver/jobProfileDriverAssignSea";
import documents from "@/components/JobDocuments/documents";
import additionalChargesPopup from "@/components/JobDocuments/additionalChargesPopup";
import generateAdvancePopup from "@/components/JobDocuments/generateAdvancePopup";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ErrorBox from "@/components/Common/ErrorBox";
import MilestoneTemplate from "@/components/Common/MilestoneTemplate";
import Swal from "sweetalert2";
import moment from "moment";
import { jobDetailAssignmentList } from "@/constants/datatable-headers.js";
import Loading from "vue-loading-overlay";
import {
  getOperatorAssignmentLabel,
  getOperatorDetailsLabel,
  getOperatorLabel,
  getOperatorPriceLabel,
  getOperatorRoleLabel,
  getUnitNoLabel,
  getUnitTypeLabel,
} from "@/utils/shipmentLabels";
import {
  driverDocPdf,
  removeDriver,
  jobsProfileAssignmentList,
} from "../../../constants/api-urls";
let momentTz = require("moment-timezone");
export default {
  created() {
    this.$eventBus.$on("job-details-purchase-invoice", (data) => {
      this.jobAssignments.filter((x) => {
        if (x.assignmentId == data.socketPurchInvoiceData.assignmentId) {
          this.$emit("updateJobs");
        }
      });
    });
    this.$eventBus.$on("job-details-purchase-order", (data) => {
      this.jobAssignments.filter((x) => {
        if (x.assignmentId == data.socketPurchData.assignmentId) {
          this.$emit("updateJobs");
        }
      });
    });
    this.$eventBus.$on("togglePurchaseInvoiceSwitch", (data) => {
      console.log(data);
      this.$emit("updateJobs");
    });

    this.$eventBus.$on("shpiment-dialog-close", () => {
      this.shipmentdialog = false;
    });
    this.$eventBus.$on("delivery-dialog-close", () => {
      this.deliveryDialog = false;
    });
    this.$eventBus.$on("advance-dialog-close", () => {
      this.advancedialog = false;
    });
    this.date = new Date();
    let options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    if (this.$props.workingcountry === "UAE") {
      this.timeZone = "Asia/Dubai";
      this.emailTimeZone = "Gulf Standard Time";
    } else if (this.$props.workingcountry === "KSA") {
      this.timeZone = "Asia/Riyadh";
      this.emailTimeZone = "Saudi Arabia Standard";
    } else if (this.$props.workingcountry === "PAK") {
      this.timeZone = "Asia/Karachi";
      this.emailTimeZone = "Pakistan Standard Time";
    } else {
      this.timeZone = "Asia/Dubai";
      this.emailTimeZone = "Gulf Standard Time";
    }

    options.timeZone = this.timeZone;
    this.currentDate = this.date.toLocaleString("en-US", options);
    this.$eventBus.$on("driver-assignment", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("job-details-sales-order", (data) => {
      console.log(data);
      if (this.$route.params.id == data.socketSalesOrderData.jobId) {
        this.$eventBus.$emit("refresh-job");
      }
    });
    this.$eventBus.$on("unassign-asset", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("assign-asset", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("sales-invoice-assignment", () => {
      setTimeout(() => {
        this.$eventBus.$emit("refresh-job");
      }, 5000);
      this.$emit("updateJobs");
    });
    this.$eventBus.$on("cancelled", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("payment-completed", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("unassigned-completed", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("milestoneChecked-completed", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.$eventBus.$on("assignment-completed", () => {
      this.$eventBus.$emit("refresh-job");
    });
    this.communicateDialog.to = this.$props.userDetail
      ? this.$props.userDetail.email
      : "";
  },
  beforeDestroy() {
    this.$eventBus.$off("unassigned-completed");
    this.$eventBus.$off("driver-assignment");
    this.$eventBus.$off("milestoneChecked-completed");
    this.$eventBus.$off("payment-completed");
    this.$eventBus.$off("cancelled");
    this.$eventBus.$off("assign-asset");
    this.$eventBus.$off("unassign-asset");
    this.$eventBus.$off("assignment-completed");
    this.$eventBus.$off("shpiment-dialog-close");
    this.$eventBus.$off("delivery-dialog-close");
    this.$eventBus.$off("advance-dialog-close");
  },
  mounted() {
    delete this.axios.defaults.headers.common["token"];
    let token = localStorage.getItem(StorageKeys.SessionKey);
    let config = {
      headers: {
        authorization: `bearer ${token}`,
      },
    };
    this.t = config.headers.authorization;
  },
  props: [
    "workingcountry",
    "milestoneItemsList",
    "driverDoc",
    "assignments",
    "milestoneItemsList",
    "jobId",
    "journeyDays",
    "jobData",
    "job",
    "loader",
    "userDetail",
    "steps",
    "milestoneList",
    "profile",
    "tabOrder",
    "jobType",
    "viewOnly",
  ],
  computed: {
    modeAwareHeaders() {
      return jobDetailAssignmentList.map((header) => {
        if (header.value === "truckNumber") {
          return { ...header, text: getUnitNoLabel(this.jobType) };
        }
        if (header.value === "driverDetail") {
          return {
            ...header,
            text: getOperatorAssignmentLabel(this.jobType),
          };
        }
        return header;
      });
    },
  },
  data() {
    return {
      dialog6: false,
      dialog7: false,
      errorMessage: null,
      processing: false,
      assignmentData: {},
      errorTitle: null,

      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      confirmation: "",
      confirmationDialog: {
        cancelAssignment: false,
        makePayment: false,
        completeAssignment: false,
        removeDriverAssignment: false,
        removeTransporterAssignment: false,
      },
      date: "",
      noRole: false,
      isassetForm: false,
      index: "",
      emailTimeZone: "Gulf Standard Time",
      timeZone: "",
      milestoneTrack: {
        milestone: [],
        assId: null,
      },
      shipmentdialog: false,
      advancedialog: false,
      additionalChargesdialog: false,
      deliveryDialog: false,
      journeyDis: "",
      currentDate: "",
      truckTypes: TruckTypes,
      AirTypes: AirTypes,
      SeaTypes: SeaTypes,
      documentStatuses: [
        { text: "Pending", value: "Pending" },
        { text: "Fulfilled", value: "Fulfilled" },
      ],
      documentStatus: "Pending",
      milestoneItems: [],
      podStatus: false,
      emailDialog: false,
      message: "",
      title: "",
      dialog8: false,
      dialogForVas: false,
      activeAssignmentId: null,
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      jobAssignments: this.assignments,
      customer: null,
      loading: false,
      x: {
        message: "",
        loading: false,
        success: false,
        error: null,
      },
      communicateDialog: {
        error: "",
        success: "",
        show: false,
        to: "",
        type: "milestone",
        subject: null,
        cc: null,
        select: [],
        items: [],
        search: "", //sync search
      },
      dialog: false,
      items: [],
      search: "",
      vasMessagePopup: "",
      vasAssignmentData: {},
      error: null,
      jobDetails: {
        jobInfo: {
          jobId: null,
          jobStatus: null,
          startDate: null,
          sourceLocation: null,
          destinationLocation: null,
        },
      },
      t: null,
    };
  },
  watch: {
    assignments(val) {
      this.jobAssignments = val;
      this.activeAssignmentId = null;
    },
    milestoneList(val) {
      this.milestoneItems = val;
    },
  },
  components: {
    JobsProfileAssignmentDetail,
    jobProfileDriverAssignAir,
    ChangeDriver,
    GpsCollectionPopup,
    jobProfileDriverAssignSea,
    ConfirmationDialog,
    AddDocument,
    ReceiveDriverDocPopup,
    JobsProfileDriverAssign,
    ValueAdded,
    generateAdvancePopup,
    additionalChargesPopup,
    addProofOfDelivery,
    AssetUnassign,
    documents,
    Loading,
    AssetAssign,
    GenerateAdvance,
    ErrorBox,
    SuccessDialog,
    MilestoneTemplate,
  },
  methods: {
    getModeAwareAssignmentStatus(status) {
      const statusLabel = this.assignmentStatus(status) || "";
      return statusLabel.replace(
        /Driver/g,
        getOperatorRoleLabel(this.jobType)
      );
    },
    getOperatorAssignedLabel(mode) {
      return `${getOperatorRoleLabel(mode)} Assigned`;
    },
    getOperatorNotAssignedYetLabel(mode) {
      return `${getOperatorRoleLabel(mode)} not assigned yet`;
    },
    getOperatorLabel,
    getOperatorDetailsLabel,
    getOperatorPriceLabel,
    getUnitTypeLabel,
    isAssignmentExpanded(item) {
      return this.activeAssignmentId === item.assignmentId;
    },
    toggleAssignment(props) {
      const nextAssignmentId = props.item.assignmentId;
      const shouldOpen =
        this.activeAssignmentId !== nextAssignmentId || !props.expanded;
      props.expanded = shouldOpen;
      this.activeAssignmentId = shouldOpen ? nextAssignmentId : null;
    },
    closeAssignmentFocus(props) {
      props.expanded = false;
      this.activeAssignmentId = null;
    },
    refresh() {
      this.$emit("updateJobs");
    },
    refreshListViaVas() {
      console.log("refres------");
      this.dialogForVas = false;
      this.$emit("updateJobs");
    },
    openVas(assignData) {
      this.vasMessagePopup = ` Are you sure you want to add duty for assignment Id- ${assignData.assignmentId}?`;
      this.dialogForVas = true;
      this.vasAssignmentData = assignData;
    },
    closeMessage() {
      this.x.success = false;
      // this.componentKey += 1;
      this.$emit("on-block");
      this.$emit("account-list-refresh");
    },
    errorDoc() {
      this.error = "Kindly assign driver!";
    },
    openTransporterUnassign(assignData) {
      this.confirmationDialog.removeTransporterAssignment = true;
      this.assignmentData = { ...assignData };
    },
    openDriverUnassign(assignData) {
      this.confirmationDialog.removeDriverAssignment = true;
      this.assignmentData = { ...assignData };
    },
    driverpdfDownload(data) {
      this.$eventBus.$emit("on-load");
      let url = "/dmsAdmin/driverDocPdf";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { driverId: data.driverData.driverId };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.$eventBus.$emit("off-load");
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          this.$emit("driverPdfPopUpClosed", false);
          // Set the HREF to a Blob representation of the data to be downloaded
          a.href = response.data.data;
          a.download = "documents" + data.driverData.driverId;
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        },
        (error) => {
          this.loading = false;
          this.$eventBus.$emit("off-load");
          this.error = error.response.data.message;
        }
      );
    },

    checkChangeDriver(assignmentDetails) {
      // Hide once the shipment is offloaded (SHIPMENT_OFFLOADED)
      if (assignmentDetails.assignmentStatus == 6) {
        return false;
      } else if (
        assignmentDetails.hasVasAttached &&
        assignmentDetails.isDocRecievedForVasAssignment == false
      ) {
        return true;
      } else if (
        (assignmentDetails.assignmentStatus == 2 ||
          assignmentDetails.assignmentStatus == 5 ||
          assignmentDetails.assignmentStatus == 7) &&
        assignmentDetails.assignmentType != "Value Added Service" &&
        !assignmentDetails.hasVasAttached
      ) {
        return true;
      } else {
        return false;
      }
    },
    errorOpen(data) {
      if (!data.assetId) {
        this.dialog6 = true;
        this.errorTitle = "Error Message";
        this.errorMessage = "Please assign IMEI on the assignment !";
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      } else {
        this.$emit("driverAssetPopUpClosed", false);
        let routeData = this.$router.resolve(
          `/asset/${data.assignmentId}/asset-form`
        );
        window.open(routeData.href, "_blank");
      }
    },
    driverErrorOpen(data) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.error = "";
        }, 3000);
        return;
      }
      if (data.assignmentStatus < 2) {
        this.dialog7 = true;
        this.errorTitle = "Error Message";
        this.errorMessage = "Please assign driver on the assignment !";
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      } else {
        this.$emit("driverFormPopUpClosed", false);
        let routeData = this.$router.resolve(
          `/driver/${data.driverData.driverId}/driver-form`
        );
        window.open(routeData.href, "_blank");
      }
    },
    removeDriver() {
      this.confirmationDialog.removeDriverAssignment = false;
    },
    remove() {
      this.confirmationDialog.removeTransporterAssignment = false;
    },
    removeTransporterAssignment(data) {
      if (
        data.assignmentStatus == 2 ||
        data.assignmentStatus == 5 ||
        data.assignmentStatus == 6
      ) {
        this.error = "Please unassign the driver first !";
        this.loading = false;
        return;
      }
      this.loading = true;
      let url = "/dmsAdmin/unassignTransporter";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.confirmationDialog.removeTransporterAssignment = false;
          this.$emit("updateJobs");
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },
    removeDriverAssignment(data) {
      this.loading = true;
      if (!data.driverData) {
        this.loading = false;

        return;
      }
      let url = "/dmsAdmin/removeDriver";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const body = {
        driverId: data.driverData.driverId.toString(),
        assignmentId: data.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.$emit("updateJobs");
          this.loading = false;
          this.confirmationDialog.removeDriverAssignment = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },
    noInternet() {
      if (!navigator.onLine) {
        this.loading = false;
        Swal.fire({
          title: "Oops!",
          text: "Your internet connection seems to be offline.Please try again.",
          type: "error",
          allowOutsideClick: false,
          confirmButtonColor: "orange",
          confirmButtonText: "Okay",
        }).then((result) => {
          if (result.value) {
          }
        });
      }
    },

    async checkCommunication(section) {
      // this.processing=true;
      this.noRole = false;
      this.operationName = "communicate-customer-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = false;
        this.noRole = false;
      } else {
        this.processing = false;
        this.noRole = true;
        return;
      }
    },
    async checkSendCommunication() {
      this.noRole = false;
      this.processing = true;
      this.operationName = "communicate-customer-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = false;
        this.sendCommunication();
      } else {
        this.processing = false;
        return;
      }
    },
    goToProfile(jobId, assignId, _id) {
      this.$router.push(`/documents/${_id}`);
      localStorage.setItem("cust-status", this.viewOnly);
    },
    calculateDistance() {
      let url = jobsProfileAssignmentList.journeyDistance;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        JobId: this.jobId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.journeyDis = response.data.data.journeyDis;
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },

    getText(arr = [], val) {
      let finalEl = null;

      finalEl = arr.find((el) => el.value === val.toString());

      return finalEl ? finalEl.text : "NA";
    },
    smartRecipent() {
      this.items = [];

      if (this.search && this.search.trim().length > 0) {
        let url = jobsProfileAssignmentList.smartRecipent;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          jobId: this.$props.jobId.toString(),
          searchText: this.search.trim(),
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.items = response.data.data;
          },
          (error) => {
            this.error = error.response.data.message;
          }
        );
      } else {
        this.search = "";
      }
    },
    changeDocumentStatus(Id, index) {
      let url = jobsProfileAssignmentList.changeDocumnetStatus;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assignId: Id.toString(),
        status: this.assignments[index].docStatus,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.success = true;
          this.x.message = response.data.message;
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
    open() {
      this.dialog8 = true;
      this.title = "POD Status";
      this.message = "Are sure want to change the status?";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
      this.podStatus = true;
    },
    cancel8() {
      this.resolve(false);
      this.dialog8 = false;
    },
    checkValue() {
      if (this.communicateDialog.select) {
        this.communicateDialog.select = this.communicateDialog.select.filter(
          function (el) {
            return el.trim().length > 0;
          }
        );
        this.items = [];
      }
      this.search = "";
    },
    updateTags() {
      this.$nextTick(() => {
        this.search = this.search.trim();
        this.communicateDialog.select.push(...this.search.split(","));
        this.$nextTick(() => {
          this.search = "";
        });
      });
    },
    sendCommunication() {
      this.communicateDialog.success = "";
      this.communicateDialog.error = "";

      let url = jobsProfileAssignmentList.sendCommunication;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      if (!this.communicateDialog.subject) {
        this.communicateDialog.error = "Please provide a suitable subject";
        setTimeout(() => {
          this.communicateDialog.error = "";
        }, 7000);
        this.loading = false;
        return false;
      }
      let body = {
        jobId: this.jobDetails.jobInfo.jobId.toString(),
        subject: this.communicateDialog.subject,
        type: "",
      };
      if (this.communicateDialog.select.length) {
        let count_valid = 0;
        // let regex = '/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/';
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        for (let k = 0; k < this.communicateDialog.select.length; k++) {
          this.communicateDialog.select[k] =
            this.communicateDialog.select[k].trim();

          if (re.test(this.communicateDialog.select[k])) {
            count_valid = count_valid + 1;
          }
        }
        if (count_valid !== this.communicateDialog.select.length) {
          this.communicateDialog.error =
            "Please make sure all the emails are properly formed";
          setTimeout(() => {
            this.communicateDialog.error = "";
          }, 7000);
          this.loading = false;
          return false;
        }
      }
      if (this.communicateDialog.select.length) {
        body.cc = this.communicateDialog.select;
      }
      if (this.communicateDialog.type === "milestone") {
        if (this.profile.jobStatus == 6) {
          body.status = "InTransit";
        }
        if (
          this.profile.jobStatus == 7 ||
          this.profile.jobStatus == 8 ||
          this.profile.jobStatus == 9 ||
          this.profile.jobStatus == 2
        ) {
          body.status = "Offloaded";
        }
        body.type = "milestone";
      } else if (this.communicateDialog.type === "paymentPending") {
        body.type = "paymentPending";
      } else if (this.communicateDialog.type === "paymentDone") {
        body.type = "paymentDone";
      } else if (this.communicateDialog.type === "complete") {
        body.type = "complete";
      } else if (this.communicateDialog.type === "cancel") {
        body.type = "cancel";
      } else {
        if (this.profile.jobStatus == 6) {
          body.status = "InTransit";
        }
        if (
          this.profile.jobStatus == 7 ||
          this.profile.jobStatus == 8 ||
          this.profile.jobStatus == 9 ||
          this.profile.jobStatus == 2
        ) {
          body.status = "Offloaded";
        }
        body.type = "driver";
      }
      let { apiUrl } = this.constants;
      this.loading = true;
      this.axios
        .post(`${apiUrl}/dmsAdmin/sendCommunication`, body, config)
        .then(
          (response) => {
            this.communicateDialog.success =
              "Email has been sent successfully!";
            this.communicateDialog.subject = "";
            this.communicateDialog.select = [];
            this.items = [];
            this.search = "";
            this.loading = false;
            this.$eventBus.$emit("refresh-job");
            setTimeout(() => (this.communicateDialog.success = ""), 7000);
          },
          (error) => {
            this.communicateDialog.error = error.response.data.message;
            setTimeout(() => (this.communicateDialog.error = ""), 7000);
            this.loading = false;
          }
        );
    },
    getTime3(date) {
      return moment.utc(date).format("MMM DD YYYY HH:mm");
    },
    getTime4(date) {
      return moment.utc(date).format("MMM DD YYYY ");
    },
    getDateTime2(time) {
      return moment.utc(time).format("DD-MM-YYYY");
    },
    getDateTime3(time) {
      return moment(time).tz(this.timeZone).format("DD-MM-YYYY HH:mm");
    },
    getDateTimeCurrent(time) {
      return moment(time).format("DD-MM-YYYY HH:mm");
    },
    getDateTime(time) {
      // let x = new Date(time);
      return moment.unix(time).format("DD/MM/YYYY hh:mm A");
    },
    getJobStatus(status) {
      switch (status) {
        case 1:
          return "Active";
        case 2:
          return "Completed";
        case 3:
          return "Customer Rate Accepted";
        case 4:
          return "Finding Drivers";
        case 5:
          return "Driver Assigned";
        case 6:
          return "In-Transit";
        case 7:
          return "Off-Loaded/Delivered";
        case 8:
          return "Payment Pending";
        case 9:
          return "Payment Done";
        case 10:
          return "Low Credit Limit";
        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    showCommunicate(type) {
      this.communicateDialog.to = this.$props.userDetail.email;

      this.communicateDialog.success = "";
      this.communicateDialog.error = "";
      this.communicateDialog.subject = "";
      this.communicateDialog.select = [];
      if (type === "milestone") {
        this.communicateDialog.type = "milestone";
      } else if (type === "paymentPending") {
        this.communicateDialog.type = "paymentPending";
      } else if (type === "paymentDone") {
        this.communicateDialog.type = "paymentDone";
      } else if (type === "complete") {
        this.communicateDialog.type = "complete";
      } else if (type === "cancel") {
        this.communicateDialog.type = "cancel";
      } else {
        this.communicateDialog.type = "driver";
      }

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: this.$props.jobId.toString(),
      };
      let { apiUrl } = this.constants;
      this.loading = true;
      this.communicateDialog.show = true;
      this.axios.post(`${apiUrl}/dmsAdmin/jobDetails`, body, config).then(
        (response) => {
          this.loading = false;
          const data = response.data.data;
          this.items = [];
          this.search = "";

          this.jobDetails = response.data.data;
          if (this.jobDetails.jobInfo.cc)
            this.communicateDialog.select = this.jobDetails.jobInfo.cc;

          if (this.jobDetails.jobInfo.subject)
            this.communicateDialog.subject = this.jobDetails.jobInfo.subject;
          for (let i = 0; i < this.assignments.length; i++) {
            if (this.assignments[i].completedCheckList) {
              this.assignments[i].currentChecklist =
                this.assignments[i].completedCheckList[
                  this.assignments[i].completedCheckList.length - 1
                ];
              this.assignments[i].updatedChecklistOn =
                this.assignments[i].completedCheckList[
                  this.assignments[i].completedCheckList.length - 1
                ].updatedAt;

              this.assignments[i].upcomingChecklistName = "";
              this.assignments[i].currentChecklistName = "";
              for (
                let j = 0;
                j < this.assignments[i].milestoneData.checkList.length;
                j++
              ) {
                if (
                  this.assignments[i].currentChecklist.checkListId ===
                  this.assignments[i].milestoneData.checkList[j]._id
                ) {
                  this.assignments[i].currentChecklistName =
                    this.assignments[i].milestoneData.checkList[j].name;
                }
              }
            }
          }
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },
    closeMessage() {
      this.x.success = false;
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded ";

        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    updateCustomer(jobId) {
      let url = jobsProfileAssignmentList.updateTrackStatusToCust;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: jobId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.success = true;
          this.x.message = response.data.message;
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
    updateAssignment() {
      this.$emit("updateJobs");
    },
    getDriverAssignment(assignment) {
      return assignment.driverFirstName
        ? `${assignment.driverFirstName} ${assignment.driverLastName}`
        : "-";
    },
  },
};
</script>
<style lang="scss">
.assignments-modern-card {
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: hidden;
}

.assignments-table-shell {
  padding: 0 !important;
}

.assignments-modern-table {
  background: #ffffff;
}

.assignments-modern-table .v-table__overflow {
  border-top: 1px solid #edf1f7;
  max-height: none;
  overflow: hidden !important;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  width: 100%;
}

.assignments-modern-table table.v-table {
  min-width: 0;
}

.assignments-modern-table table.v-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
}

.assignments-modern-table table.v-table tbody tr {
  background: #ffffff;
}

.assignments-modern-table table.v-table tbody tr:hover {
  background: #fffaf5;
}

.assignments-modern-table .assignment-row {
  border-left: 3px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.assignments-modern-table .assignment-row--active {
  background: #fffaf5 !important;
  border-left-color: #f58220;
}

.assignment-focus-shell {
  background: #f4f6fa;
  border-top: 1px solid #e1e7f0;
}

.assignment-focus-header {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e1e7f0;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  margin: 8px 8px 0;
  padding: 8px 10px;
}

.assignment-focus-header span {
  color: #667085;
  display: block;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
}

.assignment-focus-header strong {
  color: #172033;
  display: block;
  font-size: 15px;
  font-weight: 900;
  margin-top: 2px;
}

.assignment-focus-close {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #a85510;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 900;
  min-height: 30px;
  padding: 6px 9px;
}

.assignments-modern-card {
  border-radius: 8px !important;
  box-shadow: none !important;
}

.assignments-table-shell {
  padding: 0 !important;
}

.assignments-modern-table table.v-table {
  min-width: 0;
}

.assignments-modern-table table.v-table thead th {
  height: 38px;
}

.assignments-modern-table table.v-table tbody td {
  height: 42px;
  padding: 7px 10px !important;
}

.assignment-focus-shell {
  background: #ffffff;
}

.assignment-focus-header {
  border-left: 0;
  border-radius: 0;
  border-right: 0;
  margin: 0;
}

.assignment-focus-close {
  background: #ffffff;
  border-radius: 6px;
  min-height: 28px;
  padding: 5px 8px;
}

.assignments-modern-card {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.assignments-modern-card > .v-card__title.bg-clr {
  background: transparent !important;
  border-bottom: 1px solid #e7ebf2;
  min-height: 36px !important;
  padding: 5px 8px !important;
}

.assignments-modern-card > .v-card__title .heading {
  font-size: 13px;
  font-weight: 900;
  padding: 0 !important;
}

.assignments-modern-card .communicate-btn {
  min-height: 26px !important;
  padding: 4px 9px !important;
}

.assignments-modern-table .v-table__overflow {
  border: 0;
  max-height: none;
}

.assignments-modern-table table.v-table {
  border-collapse: collapse;
}

.assignments-modern-table table.v-table thead th {
  background: #fbfcfe !important;
  border-bottom: 1px solid #dfe4ec !important;
  color: #7a8494 !important;
  font-size: 10px !important;
  height: 32px;
}

.assignments-modern-table table.v-table tbody td {
  border-bottom: 1px solid #eef1f6 !important;
  color: #111827;
  font-size: 11px !important;
  height: 36px;
  padding: 5px 8px !important;
}

.assignments-modern-table .assignment-row {
  border-left: 2px solid transparent;
}

.assignments-modern-table .assignment-row--active {
  background: #fffaf5 !important;
  border-left-color: #f58220;
}

.assignment-focus-shell {
  animation: assignmentAccordionIn 0.16s ease;
  background: #fbfcfe;
  border-bottom: 1px solid #dfe4ec;
  border-top: 1px solid #dfe4ec;
}

.assignment-focus-header {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #eef1f6;
  border-radius: 0;
  margin: 0;
  min-height: 32px;
  padding: 5px 9px;
}

.assignment-focus-header span {
  font-size: 9px;
}

.assignment-focus-header strong {
  font-size: 13px;
  margin-top: 0;
}

.assignment-focus-close {
  background: transparent;
  border: 1px solid #dfe4ec;
  color: #667085;
  min-height: 24px;
  padding: 3px 8px;
}

@keyframes assignmentAccordionIn {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.assignments-modern-card,
.assignments-table-shell,
.assignments-modern-table,
.assignments-modern-table .v-table__overflow,
.assignment-focus-shell,
.assignment-focus-shell .assignment-detail-panel {
  max-height: none !important;
  overflow: hidden !important;
}

.assignments-modern-table table.v-table {
  min-width: 0 !important;
  table-layout: fixed;
  width: 100% !important;
}

.assignments-modern-table table.v-table th,
.assignments-modern-table table.v-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
}

.assignments-modern-table .v-table__overflow {
  border: 0;
  width: 100%;
}

.assignment-focus-shell {
  width: 100%;
}

.assignment-focus-shell .assignment-detail-panel {
  width: 100%;
}

.v-table__overflow {
  width: 100%;
  overflow: hidden !important;
}
.minHeight {
  min-height: 300px;
}

thead {
  background: #fbfbfb;
}

.assignments-modern-card {
  --assignment-action-accent: #f58220;
  --assignment-action-accent-dark: #b45309;
  --assignment-action-border: #fed7aa;
  --assignment-action-muted: #667085;
  --assignment-action-muted-bg: #f8fafc;
  --assignment-action-danger: #b42318;
}

.assignments-modern-card .assignments-action-btn,
.assignments-modern-card .track-ass-btn,
.assignments-modern-card .track-assign-btn,
.assignments-modern-card .communicate-btn,
.assignments-modern-card .assignment-focus-close {
  align-items: center !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 700 !important;
  gap: 6px;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  min-height: 28px !important;
  padding: 7px 11px !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, transform 0.15s ease;
  white-space: normal !important;
}

.assignments-modern-card .assignments-action-btn::before,
.assignments-modern-card .track-ass-btn::before,
.assignments-modern-card .track-assign-btn::before,
.assignments-modern-card .communicate-btn::before {
  direction: ltr;
  display: inline-block;
  font-family: "Material Icons";
  font-feature-settings: "liga";
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: 1;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
}

.assignments-modern-card .assignments-action-btn .v-icon,
.assignments-modern-card .track-ass-btn .v-icon,
.assignments-modern-card .track-assign-btn .v-icon,
.assignments-modern-card .communicate-btn .v-icon {
  color: currentColor !important;
  font-size: 14px !important;
  margin: 0 !important;
}

.assignments-modern-card .assignments-action-btn--primary,
.assignments-modern-card .communicate-btn,
.assignments-modern-card .track-assign-btn {
  background: var(--assignment-action-accent) !important;
  border: 1px solid var(--assignment-action-accent) !important;
  color: #ffffff !important;
}

.assignments-modern-card .communicate-btn::before {
  content: "chat_bubble_outline";
}

.assignments-modern-card .track-assign-btn::before {
  content: "person_add";
}

.assignments-modern-card .assignments-action-btn--secondary,
.assignments-modern-card .track-ass-btn {
  background: #fff7ed !important;
  border: 1px solid var(--assignment-action-border) !important;
  color: var(--assignment-action-accent-dark) !important;
}

.assignments-modern-card .track-ass-btn::before {
  content: "swap_horiz";
}

.assignments-modern-card .track-ass-btn--danger {
  background: #fef3f2 !important;
  border-color: #fecdca !important;
  color: var(--assignment-action-danger) !important;
}

.assignments-modern-card .track-ass-btn--danger::before,
.assignments-modern-card .track-ass-btn--menu::before,
.assignments-modern-card .assignments-action-btn .v-icon + *,
.assignments-modern-card .track-ass-btn .v-icon + * {
  content: none;
}

.assignments-modern-card .track-ass-btn--menu {
  background: var(--assignment-action-muted-bg) !important;
  border-color: #e4e7ec !important;
  color: var(--assignment-action-muted) !important;
  min-width: 32px !important;
  padding: 6px 8px !important;
}

.assignments-modern-card .track-ass-btn--menu span {
  font-size: 0;
}

.assignments-modern-card .track-ass-btn--menu .v-icon {
  font-size: 18px !important;
}

.assignments-modern-card .assignments-action-btn:hover:not([disabled]),
.assignments-modern-card .track-ass-btn:hover:not([disabled]),
.assignments-modern-card .track-assign-btn:hover:not([disabled]),
.assignments-modern-card .communicate-btn:hover:not([disabled]),
.assignments-modern-card .assignment-focus-close:hover:not([disabled]) {
  transform: translateY(-1px);
}

.assignments-modern-card .assignments-action-btn[disabled],
.assignments-modern-card .track-ass-btn[disabled],
.assignments-modern-card .track-assign-btn[disabled],
.assignments-modern-card .communicate-btn[disabled],
.assignments-modern-card .v-btn--disabled {
  background: #f2f4f7 !important;
  border-color: #e4e7ec !important;
  color: #98a2b3 !important;
  opacity: 1 !important;
  transform: none !important;
}

.assignments-modern-card .profile-drop .v-menu__activator,
.assignments-modern-card .profile-drop .v-toolbar__side-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.assignments-modern-card .profile-drop .v-toolbar__side-icon {
  background: #f8fafc !important;
  border: 1px solid #e4e7ec !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #667085 !important;
  height: 30px !important;
  min-width: 30px !important;
}

.assignments-modern-card .profile-drop .v-toolbar__side-icon .v-icon {
  color: currentColor !important;
  font-size: 18px !important;
}

.profile-drop .v-menu__content,
.menuable__content__active {
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12) !important;
  overflow: hidden;
}

.profile-drop .v-list {
  padding: 6px !important;
}

.profile-drop .v-list__tile {
  border-radius: 7px;
  color: #344054 !important;
  font-size: 12px;
  font-weight: 700;
}

.profile-drop .v-list__tile:hover {
  background: #fff7ed !important;
  color: #b45309 !important;
}
</style>

<style scoped>
th {
  background: none !important;
  font-weight: bolder !important;
  color: black !important;
}
.payment-body {
  margin: 0 auto !important;
  padding: 0 !important;
  height: 100% !important;
  width: 100% !important;
}
.updateCustomer {
  margin-left: 55%;
}

.waybill-btn {
  padding: 10px;
  background-color: #ff9800;
  color: #fff;
  text-decoration: none;
  position: relative;
  top: 8px;
  left: 50px;
}
.m-l-5 {
  margin-left: 5px;
}
.communicate-btn {
  border: 2px solid darkorange !important;
  color: #ea7a1c !important;
  background-color: transparent !important;
}

.assignments-modern-card .communicate-btn {
  background-color: #f58220 !important;
  border: 1px solid #f58220 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  min-height: 28px !important;
  padding: 7px 11px !important;
  text-transform: none !important;
}
.orange-color {
  border-radius: 2px;
  background-color: #ea7a1c !important;
  color: #ffffff !important;
  border: 2px solid darkorange !important;
}
.comments-view .v-toolbar {
  width: 50%;
  margin-left: 25%;
}
.theme--light.v-chip {
  background: #feebd9 !important;
  color: rgb(248, 159, 69) !important;
}
.tag-input span.chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
  padding-left: 7px;
}

.tag-input span.v-chip::before {
  content: "label";
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
.info {
  padding: 10px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 10px;
}
.error.info {
  background-color: #ef5350 !important;
}
.success.info {
  background-color: #66bb6a !important;
}
.table-body tbody tr:nth-of-type(odd) {
  background-color: white !important;
}

.v-toolbar--fixed {
  position: inherit;
}
.white-button {
  border-radius: 5px;
  background-color: white !important;
  color: grey !important;
  border: 2px solid grey !important;
}
@media screen and (max-width: 767px) {
  .main-pad {
    padding: 10px !important;
  }

  .details-section {
    width: 100%;
  }

  .details-section > p {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 2px;
  }

  .details-section > p > span:first-child {
    justify-content: flex-start;
  }

  .footer p span {
    width: 100% !important;
  }

  .botm {
    text-align: left;
  }

  tr {
    display: grid;
  }

  .verified {
    float: none !important;
    margin: 0 auto !important;
  }

  .bottom {
    width: 100%;
    font-size: 11px;
  }

  .img-profile {
    float: left;
    width: 100%;
    margin-bottom: 10px;
  }

  .footer p {
    font-size: 12px !important;
  }

  .footer p img {
    margin: 0 !important;
    margin-right: 0px;
    margin-right: 13px !important;
  }
}

.main-pad {
  padding: 24px 40px;
}

/* Send Updates preview: every "Label: value" row is a two-column grid, so all
   values start on one vertical line, a wrapped value stays in its own column,
   and the colon (drawn here, not part of the label text) sits at the column
   edge so every colon lines up. */
.details-section {
  word-break: normal !important;
}

.details-section > p {
  align-items: baseline;
  column-gap: 10px;
  display: grid;
  grid-template-columns: 184px minmax(0, 1fr);
  line-height: 20px;
}

.details-section > p > span:first-child {
  display: flex !important;
  float: none !important;
  gap: 4px;
  justify-content: space-between;
  width: auto !important;
}

.details-section > p > span:first-child::after {
  content: ":";
}

/* The inline `word-break: break-all` split addresses mid-word ("Sharj / ah"). */
.details-section > p > span:last-child {
  justify-self: start;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: normal !important;
}

.details-section__note {
  color: #6b6b6b;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

/* No divider trailing at the bottom of a box; stacked assignments get one
   between them instead, with equal space above and below. */
.details-section > p:last-child {
  border-bottom: 0 !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

div:has(> .details-section) + div:has(> .details-section)::before {
  border-top: 1px solid #f2f2f2;
  content: "";
  display: block;
  margin: -10px 0 20px;
}

/* Send Updates preview: shipment progress stepper. Steps are equal-width
   columns; each marker is centred over its text, and the connector runs from
   one marker's edge to the next marker's edge along the markers' centre line.
   The !important flags beat the generic dialog table cell styles. */
.send-tracker {
  border-collapse: collapse !important;
  table-layout: fixed;
  width: 100%;
}

/* public/main.css inserts a spacer line at the top of every tbody. */
.send-tracker tbody::before {
  content: none;
  display: none;
}

.send-tracker .send-tracker__step {
  background: transparent !important;
  border: 0 !important;
  padding: 20px 6px !important;
  position: relative;
  text-align: center;
  vertical-align: top !important;
}

.send-tracker .send-tracker__step--line-done::after,
.send-tracker .send-tracker__step--line-pending::after {
  background: #d4d4d4;
  content: "";
  height: 2px;
  left: calc(50% + 18px);
  position: absolute;
  right: calc(-50% + 18px);
  top: 31px;
}

.send-tracker .send-tracker__step--line-done::after {
  background: #0f67c9;
}

.send-tracker__marker {
  background: #d4d4d4;
  border-radius: 50%;
  display: block;
  height: 24px;
  margin: 0 auto 10px;
  position: relative;
  width: 24px;
}

.send-tracker__step--done .send-tracker__marker {
  background: #0f67c9;
}

.send-tracker__step--complete .send-tracker__marker {
  background: #3fae49;
}

.send-tracker__marker::after {
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  content: "";
  height: 11px;
  left: 9px;
  position: absolute;
  top: 5px;
  transform: rotate(45deg);
  width: 6px;
}

.send-tracker__label,
.send-tracker__meta {
  display: block;
  font-size: 12px;
  line-height: 16px;
}

/* Every column shares the same rows (a two-line label area, then the count,
   then the date), so counts and dates line up across steps even when one
   label wraps and another does not. */
.send-tracker__label {
  color: #252525;
  font-weight: 700;
  margin-bottom: 4px;
  min-height: 32px;
}

.send-tracker__step--pending .send-tracker__label {
  color: #8a8a8a;
}

.send-tracker__meta {
  color: #6b6b6b;
  font-weight: 500;
}

/* Booking Confirmed has a date but no count; keep its date on the date row
   (one 16px row down; this margin collapses with the label's 4px). */
.send-tracker__label + .send-tracker__meta:last-child {
  margin-top: 20px;
}

.send-tracker-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0 16px 16px;
}

.send-tracker-actions > a {
  align-items: center;
  display: inline-flex !important;
  float: none !important;
  justify-content: center;
  line-height: 1 !important;
  margin: 0 !important;
}

@media screen and (min-width: 767px) {
  .details-section {
    width: 80%;
  }

  .img-profile {
    width: 20%;
  }
}

.bottom {
  float: left;
}
p {
  margin-bottom: 15px !important;
}
</style>

<style lang="scss">
.job-dossier--modern .assignments-modern-card {
  --assignment-inline-primary: #3157d5;
  --assignment-inline-accent: #b45309;
  --assignment-inline-muted: #475467;
  --assignment-inline-danger: #b42318;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token,
.job-dossier--modern .assignments-modern-card .assignments-action-btn,
.job-dossier--modern .assignments-modern-card .track-ass-btn,
.job-dossier--modern .assignments-modern-card .track-assign-btn,
.job-dossier--modern .assignments-modern-card .communicate-btn,
.job-dossier--modern .assignments-modern-card .assignment-focus-close {
  align-items: center !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  color: var(--assignment-inline-primary) !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 600 !important;
  gap: 6px;
  height: auto !important;
  justify-content: flex-start;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  margin: 0 !important;
  min-height: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: color 0.15s ease, opacity 0.15s ease;
  vertical-align: baseline;
  white-space: normal !important;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token:hover:not([disabled]),
.job-dossier--modern .assignments-modern-card .assignments-action-btn:hover:not([disabled]),
.job-dossier--modern .assignments-modern-card .track-ass-btn:hover:not([disabled]),
.job-dossier--modern .assignments-modern-card .track-assign-btn:hover:not([disabled]),
.job-dossier--modern .assignments-modern-card .communicate-btn:hover:not([disabled]),
.job-dossier--modern .assignments-modern-card .assignment-focus-close:hover:not([disabled]) {
  color: #1d3fa6 !important;
  opacity: 0.88;
  transform: none !important;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token .v-icon,
.job-dossier--modern .assignments-modern-card .assignments-action-btn .v-icon,
.job-dossier--modern .assignments-modern-card .track-ass-btn .v-icon,
.job-dossier--modern .assignments-modern-card .track-assign-btn .v-icon,
.job-dossier--modern .assignments-modern-card .communicate-btn .v-icon {
  color: currentColor !important;
  font-size: 14px !important;
  height: 14px !important;
  line-height: 14px !important;
  margin: 0 !important;
  width: 14px !important;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token::before,
.job-dossier--modern .assignments-modern-card .assignments-action-btn::before,
.job-dossier--modern .assignments-modern-card .track-ass-btn::before,
.job-dossier--modern .assignments-modern-card .track-assign-btn::before,
.job-dossier--modern .assignments-modern-card .communicate-btn::before {
  color: currentColor;
  font-size: 14px;
  line-height: 14px;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token--secondary,
.job-dossier--modern .assignments-modern-card .assignments-action-btn--secondary {
  color: var(--assignment-inline-accent) !important;
}

.job-dossier--modern .assignments-modern-card .track-ass-btn--danger {
  color: var(--assignment-inline-danger) !important;
}

.job-dossier--modern .assignments-modern-card .track-ass-btn--danger:hover:not([disabled]) {
  color: #8a1f16 !important;
}

.job-dossier--modern .assignments-modern-card .track-ass-btn--menu {
  align-items: center !important;
  border-radius: 999px !important;
  color: var(--assignment-inline-muted) !important;
  height: 22px !important;
  justify-content: center !important;
  width: 22px !important;
}

.job-dossier--modern .assignments-modern-card .track-ass-btn--menu .v-icon {
  font-size: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  width: 18px !important;
}

.job-dossier--modern .assignments-modern-card .track-ass-btn--menu span {
  display: none;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token[disabled],
.job-dossier--modern .assignments-modern-card .assignments-action-btn[disabled],
.job-dossier--modern .assignments-modern-card .track-ass-btn[disabled],
.job-dossier--modern .assignments-modern-card .track-assign-btn[disabled],
.job-dossier--modern .assignments-modern-card .communicate-btn[disabled],
.job-dossier--modern .assignments-modern-card .v-btn--disabled {
  background: transparent !important;
  border: 0 !important;
  color: #98a2b3 !important;
  opacity: 1 !important;
  pointer-events: auto;
  transform: none !important;
}

.job-dossier--modern .assignments-modern-card #dataTable table.v-table tbody td {
  vertical-align: middle;
}

.job-dossier--modern .assignments-modern-card #dataTable table.v-table tbody td .layout,
.job-dossier--modern .assignments-modern-card #dataTable table.v-table tbody td .flex {
  align-items: center;
}

.job-dossier--modern .assignments-modern-card .profile-drop .v-toolbar__side-icon {
  background: transparent !important;
  border: 0 !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: var(--assignment-inline-muted) !important;
  height: 22px !important;
  min-width: 22px !important;
  padding: 0 !important;
}

.job-dossier--modern .profile-drop .v-list__tile {
  color: #344054 !important;
  font-size: 12px;
  font-weight: 600;
}

.job-dossier--modern .assignments-modern-card .assignment-document-view-link {
  align-items: center !important;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 7px !important;
  box-shadow: none !important;
  color: #a85510 !important;
  display: inline-flex !important;
  float: none !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  gap: 5px;
  height: 28px !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 28px !important;
  margin: 0 !important;
  min-height: 28px !important;
  min-width: 0 !important;
  padding: 0 10px !important;
  position: static !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: background-color 0.16s ease, border-color 0.16s ease,
    color 0.16s ease, transform 0.16s ease;
  white-space: nowrap !important;
  width: auto !important;
}

.job-dossier--modern .assignments-modern-card .assignment-document-view-link img {
  height: 14px !important;
  margin-right: 6px !important;
  object-fit: contain;
  vertical-align: middle !important;
  width: 14px !important;
}

.job-dossier--modern .assignments-modern-card .assignment-document-view-link:hover {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #8a420b !important;
  transform: translateY(-1px);
}

.theme--dark .job-dossier--modern .assignments-modern-card .assignment-document-view-link,
.application--dark .job-dossier--modern .assignments-modern-card .assignment-document-view-link {
  background: rgba(245, 130, 32, 0.16) !important;
  border-color: rgba(245, 130, 32, 0.34) !important;
  color: #fdba74 !important;
}

.job-dossier--modern .assignments-modern-card {
  border: 1px solid #e7ebf2 !important;
  border-radius: 8px !important;
  box-shadow: 0 14px 30px rgba(17, 24, 39, 0.05) !important;
  min-width: 0;
  overflow: visible !important;
}

.job-dossier--modern .assignments-modern-card > .v-card__title.bg-clr {
  background: #ffffff !important;
  border-bottom: 1px solid #eef1f6;
  display: block !important;
  min-height: 0 !important;
  padding: 0.875rem 1rem !important;
}

.job-dossier--modern .assignments-modern-card > .v-card__title.bg-clr > .layout {
  align-items: center;
  display: grid !important;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr) auto auto;
  margin: 0 !important;
  min-width: 0;
}

.job-dossier--modern .assignments-modern-card > .v-card__title.bg-clr > .layout > .flex {
  flex: 0 1 auto !important;
  max-width: none !important;
  min-width: 0;
  padding: 0 !important;
  width: auto !important;
}

.job-dossier--modern .assignments-modern-card > .v-card__title .heading {
  color: #303030;
  font-size: 1rem !important;
  font-weight: 900;
  line-height: 1.25;
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal !important;
}

.job-dossier--modern .assignments-table-shell,
.job-dossier--modern .assignments-modern-table,
.job-dossier--modern .assignments-modern-table .v-table__overflow {
  min-width: 0;
  width: 100%;
}

.job-dossier--modern .assignments-table-shell {
  overflow: visible !important;
}

.job-dossier--modern .assignments-modern-table .v-table__overflow {
  -webkit-overflow-scrolling: touch;
  overflow-x: auto !important;
  overflow-y: visible !important;
  scrollbar-gutter: stable;
}

.job-dossier--modern .assignments-modern-table table.v-table {
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
  min-width: 110rem !important;
  width: 100% !important;
}

.job-dossier--modern .assignments-modern-table table.v-table th,
.job-dossier--modern .assignments-modern-table table.v-table td {
  box-sizing: border-box;
  max-width: 17rem;
  min-width: 7rem;
  overflow: visible !important;
  padding: 0.75rem 0.625rem !important;
  text-overflow: clip !important;
  vertical-align: middle !important;
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: anywhere;
}

.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(1) {
  min-width: 5rem;
  max-width: 7rem;
}

.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(2),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(3),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(9),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(10),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(11) {
  min-width: 9rem;
}

.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(4),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(5),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(6),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(7),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(8),
.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td:nth-child(12) {
  min-width: 12rem;
}

.job-dossier--modern .assignments-modern-table table.v-table tbody tr:not(.assignment-row) > td {
  max-width: none !important;
  min-width: 0 !important;
  overflow: visible !important;
  white-space: normal !important;
  width: auto !important;
}

.job-dossier--modern .assignments-modern-table table.v-table th {
  color: #667085 !important;
  font-size: 0.6875rem !important;
  font-weight: 900 !important;
  line-height: 1.25;
  text-transform: uppercase;
}

.job-dossier--modern .assignments-modern-table table.v-table td > *,
.job-dossier--modern .assignments-modern-table table.v-table td .layout,
.job-dossier--modern .assignments-modern-table table.v-table td .flex {
  max-width: 100%;
  min-width: 0;
  white-space: normal !important;
}

.job-dossier--modern .assignments-modern-table table.v-table td .layout {
  align-items: center;
  display: flex !important;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin: 0 !important;
}

.job-dossier--modern .assignments-modern-table table.v-table .assignment-row > td .layout {
  flex-wrap: nowrap;
}

.job-dossier--modern .assignments-modern-table table.v-table td .flex {
  flex: 0 1 auto !important;
  max-width: 100% !important;
  width: auto !important;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token,
.job-dossier--modern .assignments-modern-card .assignments-action-btn,
.job-dossier--modern .assignments-modern-card .track-ass-btn,
.job-dossier--modern .assignments-modern-card .track-assign-btn,
.job-dossier--modern .assignments-modern-card .communicate-btn,
.job-dossier--modern .assignments-modern-card .assignment-document-view-link {
  align-items: center !important;
  display: inline-flex !important;
  flex: 0 0 auto;
  justify-content: center !important;
  line-height: 1.15 !important;
  max-width: none;
  min-height: 1.75rem !important;
  min-width: auto !important;
  overflow-wrap: normal;
  text-align: center;
  white-space: nowrap !important;
  word-break: normal;
}

.job-dossier--modern .assignments-modern-card .assignments-action-token .v-btn__content,
.job-dossier--modern .assignments-modern-card .assignments-action-btn .v-btn__content,
.job-dossier--modern .assignments-modern-card .track-ass-btn .v-btn__content,
.job-dossier--modern .assignments-modern-card .track-assign-btn .v-btn__content,
.job-dossier--modern .assignments-modern-card .communicate-btn .v-btn__content,
.job-dossier--modern .assignments-modern-card .assignment-document-view-link span {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}

.job-dossier--modern .assignments-modern-card .communicate-btn {
  justify-content: center !important;
  text-align: center;
}

.job-dossier--modern .assignment-focus-shell {
  max-height: none !important;
  max-width: 100%;
  min-width: 0;
  overflow: visible !important;
}

.job-dossier--modern .assignment-focus-shell .assignment-detail-panel {
  max-height: none !important;
  overflow: visible !important;
}

.job-dossier--modern .assignment-focus-header {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  min-width: 0;
}

.job-dossier--modern .assignment-focus-header strong,
.job-dossier--modern .assignment-focus-header span {
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal !important;
}

@media (max-width: 760px) {
  .job-dossier--modern .assignments-modern-card > .v-card__title.bg-clr > .layout {
    align-items: flex-start;
    grid-template-columns: 1fr;
  }

  .job-dossier--modern .assignments-modern-card > .v-card__title.bg-clr > .layout > .flex {
    width: 100% !important;
  }

  .job-dossier--modern .assignments-modern-card .text-center {
    text-align: left !important;
  }

  .job-dossier--modern .assignments-modern-card > .v-card__title .communicate-btn {
    width: 100% !important;
  }

  .job-dossier--modern .assignments-modern-table table.v-table {
    min-width: 82rem !important;
  }

  .job-dossier--modern .assignments-modern-table table.v-table th,
  .job-dossier--modern .assignments-modern-table table.v-table td {
    min-width: 8.75rem;
  }
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow {
  border-bottom: 1px solid #eef1f6;
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: visible !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow > table,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow table.v-table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  max-width: none !important;
  min-width: 92rem !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td > *,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td .layout,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td .flex {
  max-width: 100% !important;
  overflow: hidden !important;
  overflow-wrap: normal !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  word-break: normal !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td .layout {
  flex-wrap: nowrap !important;
  overflow: visible !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th {
  height: 3rem;
  letter-spacing: 0.04em;
  overflow-wrap: normal !important;
  white-space: normal !important;
  word-break: normal !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td {
  color: #172033;
  font-size: 0.75rem !important;
  height: 3.625rem;
  line-height: 1.3;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(1),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(1) {
  min-width: 7rem !important;
  width: 7rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(2),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(2),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(3),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(3),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(9),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(9),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(10),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(10),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(11),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(11) {
  min-width: 7rem !important;
  width: 7rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(4),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(4) {
  min-width: 7.5rem !important;
  width: 7.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(5),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(5),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(6),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(6) {
  min-width: 9rem !important;
  width: 9rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(7),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(7),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(8),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(8) {
  min-width: 8.5rem !important;
  width: 8.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(12),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(12) {
  min-width: 7.5rem !important;
  width: 7.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .pay-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .payy-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-document-view-link {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #fdba74 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #c45a0a !important;
  display: inline-flex !important;
  font-size: 0.6875rem !important;
  font-weight: 800 !important;
  gap: 0.25rem !important;
  height: 1.75rem !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: 1.75rem !important;
  min-width: 0 !important;
  padding: 0 0.5625rem !important;
  text-align: center !important;
  text-decoration: none !important;
  text-transform: none !important;
  transform: none !important;
  white-space: nowrap !important;
  width: auto !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token::before,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .pay-ass-btn::before,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .payy-ass-btn::before,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn::before,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn::before {
  content: none !important;
  display: none !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--danger {
  background: #ffffff !important;
  border-color: #fecdca !important;
  color: #b42318 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--menu {
  background: #ffffff !important;
  border-color: #d0d5dd !important;
  color: #344054 !important;
  height: 1.75rem !important;
  min-width: 1.75rem !important;
  padding: 0 !important;
  width: 1.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--menu .v-icon {
  font-size: 1rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--menu span {
  display: none !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .profile-drop .v-toolbar__side-icon {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  height: 1.75rem !important;
  min-width: 1.75rem !important;
  padding: 0 !important;
  width: 1.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token .v-icon,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn .v-icon,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn .v-icon {
  color: currentColor !important;
  font-size: 0.875rem !important;
  height: 0.875rem !important;
  line-height: 0.875rem !important;
  width: 0.875rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table button[disabled],
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-btn--disabled {
  background: #f8fafc !important;
  border-color: #e4e7ec !important;
  color: #98a2b3 !important;
  cursor: not-allowed;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card {
  overflow: hidden !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(6) .pl-3 {
  align-items: flex-start;
  display: flex !important;
  flex-direction: column;
  gap: 0.3125rem;
  overflow: visible !important;
  padding-left: 0 !important;
  white-space: nowrap !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table td:nth-child(6) .pl-3 > br {
  display: none;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr:not(.assignment-row) > td {
  max-width: none !important;
  overflow: visible !important;
  padding: 0 !important;
  white-space: normal !important;
  width: auto !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > *,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-panel,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-card,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-body {
  box-sizing: border-box;
  max-width: 100% !important;
  white-space: normal !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
  background: #fbfcfe;
  border-top: 1px solid #eef1f6;
  overflow: hidden !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-body {
  overflow: hidden !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-milestone-board {
  overflow-x: auto !important;
}

/* Final OMS alignment for the job detail assignments table and expanded segment. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card.oms-list-table-card {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: var(--oms-radius, 1rem) !important;
  box-shadow: var(--oms-shadow, 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04)) !important;
  overflow: hidden !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card > .v-card__title.bg-clr {
  background: var(--oms-surface, #ffffff) !important;
  border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  min-height: 3.25rem !important;
  padding: 0.75rem 1rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card > .v-card__title .heading {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.9375rem !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-table-shell {
  background: var(--oms-surface, #ffffff) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow > table,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow table.v-table {
  border-color: var(--oms-border, #ebe9e2) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow > table,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow table.v-table {
  border-collapse: separate !important;
  border-spacing: 0 0.125rem !important;
  min-width: 96rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table thead tr,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table thead th {
  background: var(--oms-table-header-bg, #faf9f6) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th {
  border-bottom: 0 !important;
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  height: 2.125rem !important;
  letter-spacing: 0.04em !important;
  line-height: 1.2 !important;
  padding: 0.3125rem 0.5rem !important;
  text-transform: uppercase !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row {
  background: var(--oms-surface, #ffffff) !important;
  border-left: 0.1875rem solid transparent !important;
  box-shadow: var(--oms-shadow, 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04)) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row:hover,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row--active {
  background: var(--oms-table-row-hover, #fbfaf7) !important;
  border-left-color: var(--oms-primary, #ea7a1c) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td {
  border-bottom: 0.0625rem solid var(--oms-row-divider, #f3f1eb) !important;
  color: var(--oms-ink, #3a382f) !important;
  font-size: 0.75rem !important;
  height: var(--oms-list-table-row-height, 4.25rem) !important;
  line-height: 1.35 !important;
  padding: 0.75rem !important;
  vertical-align: middle !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:first-child {
  border-bottom-left-radius: 0.625rem;
  border-top-left-radius: 0.625rem;
  color: var(--oms-ink-strong, #1a1916) !important;
  font-weight: 700;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:last-child {
  border-bottom-right-radius: 0.625rem;
  border-top-right-radius: 0.625rem;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .pay-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .payy-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-document-view-link,
.job-dossier--modern .assignment-focus-close,
.job-dossier--modern .assignment-detail-panel .v-btn:not(.v-btn--icon):not(.v-btn--fab),
.job-dossier--modern .assignment-detail-panel button:not(.v-btn--icon):not(.v-btn--fab),
.job-dossier--modern .assignment-detail-panel .track-ass-btn,
.job-dossier--modern .assignment-detail-panel .download-ass-btn,
.job-dossier--modern .assignment-detail-panel .orange-button {
  align-items: center !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  gap: 0.25rem !important;
  height: var(--oms-control-height, 2.375rem) !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: var(--oms-control-height, 2.375rem) !important;
  min-width: max-content !important;
  padding: 0 0.75rem !important;
  text-align: center !important;
  text-decoration: none !important;
  text-transform: none !important;
  transform: none !important;
  white-space: nowrap !important;
  width: auto !important;
}

.job-dossier--modern .assignment-detail-panel .pi-generate-btn,
.job-dossier--modern .assignment-detail-panel .orange-button.pi-generate-btn {
  align-items: center !important;
  display: inline-flex !important;
  height: 2rem !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0.25rem 0 0 !important;
  min-height: 2rem !important;
  min-width: 5.5rem !important;
  padding: 0 0.875rem !important;
  text-align: center !important;
}

.job-dossier--modern .assignment-detail-panel .track-ass-btn::before,
.job-dossier--modern .assignment-detail-panel .orange-button::before,
.job-dossier--modern .assignment-detail-panel .pi-generate-btn::before {
  content: none !important;
  display: none !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .pay-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .payy-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-document-view-link {
  font-size: 0.6875rem !important;
  height: 1.875rem !important;
  min-height: 1.875rem !important;
  padding: 0 0.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-details-action-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-btn--primary,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .communicate-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-assign-btn,
.job-dossier--modern .assignment-detail-panel .milestone-action-btn,
.job-dossier--modern .assignment-detail-panel .blue-button,
.job-dossier--modern .assignment-detail-panel .orange-button {
  background: var(--oms-primary, #ea7a1c) !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignments-action-token:not(.assignments-action-token--danger),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .pay-ass-btn:not(.assignment-details-action-btn),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .payy-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn:not(.track-ass-btn--danger):not(.track-ass-btn--menu),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-document-view-link,
.job-dossier--modern .assignment-focus-close,
.job-dossier--modern .assignment-detail-panel .v-btn:not(.v-btn--icon):not(.v-btn--fab):not(.orange-button):not(.milestone-action-btn),
.job-dossier--modern .assignment-detail-panel button:not(.v-btn--icon):not(.v-btn--fab):not(.orange-button):not(.blue-button):not(.milestone-action-btn),
.job-dossier--modern .assignment-detail-panel .track-ass-btn:not(.orange-button):not(.blue-button),
.job-dossier--modern .assignment-detail-panel .download-ass-btn {
  background: transparent !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  color: var(--oms-primary, #ea7a1c) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--danger,
.job-dossier--modern .assignment-detail-panel .red-button,
.job-dossier--modern .assignment-detail-panel .v-btn.error,
.job-dossier--modern .assignment-detail-panel .v-btn.red {
  background: transparent !important;
  border-color: var(--oms-red, #be3b32) !important;
  color: var(--oms-red, #be3b32) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .track-ass-btn--menu {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-color: var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-muted, #74716a) !important;
  height: 1.875rem !important;
  min-height: 1.875rem !important;
  min-width: 1.875rem !important;
  padding: 0 !important;
  width: 1.875rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-icon,
.job-dossier--modern .assignment-detail-panel .v-btn .v-icon,
.job-dossier--modern .assignment-detail-panel button .v-icon {
  color: currentColor !important;
  font-size: 0.9375rem !important;
  height: 0.9375rem !important;
  line-height: 0.9375rem !important;
  margin: 0 !important;
  width: 0.9375rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table button[disabled],
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-btn--disabled,
.job-dossier--modern .assignment-detail-panel button[disabled],
.job-dossier--modern .assignment-detail-panel .v-btn--disabled {
  background: var(--oms-disabled-bg, #f4f3ee) !important;
  border-color: var(--oms-disabled-border, #e9e6de) !important;
  color: var(--oms-disabled-ink, #b4b0a6) !important;
  opacity: 1 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr:not(.assignment-row) > td,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
  background: var(--oms-surface-soft, #faf9f6) !important;
}

.job-dossier--modern .assignment-focus-header {
  background: var(--oms-surface, #ffffff) !important;
  border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  padding: 0.75rem 1rem !important;
}

.job-dossier--modern .assignment-focus-header span {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.04em !important;
}

.job-dossier--modern .assignment-focus-header strong {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.9375rem !important;
  font-weight: 700 !important;
}

@media (max-width: 760px) {
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow > table,
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow table.v-table {
    min-width: 76rem !important;
  }
}
</style>

<style lang="scss">
/* Opened assignment row repair. Keep this last so the expanded segment is not
   compressed by older table overflow rules. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr:not(.assignment-row) > td {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-bottom: 0 !important;
  max-width: none !important;
  overflow: visible !important;
  padding: 0 !important;
  white-space: normal !important;
  width: auto !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  box-sizing: border-box;
  overflow: visible !important;
  padding: 1rem !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header {
  align-items: center !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.875rem !important;
  box-shadow: var(--oms-shadow, 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04)) !important;
  display: flex !important;
  justify-content: space-between !important;
  margin: 0 0 0.875rem !important;
  min-height: 3.5rem !important;
  padding: 0.75rem 1rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header span {
  color: var(--oms-muted, #74716a) !important;
  display: block !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.04em !important;
  line-height: 1.1 !important;
  text-transform: uppercase !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header strong {
  color: var(--oms-ink-strong, #1a1916) !important;
  display: block !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  margin-top: 0.125rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-close {
  align-items: center !important;
  background: transparent !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  color: var(--oms-primary, #ea7a1c) !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: 2.125rem !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: 2.125rem !important;
  min-width: max-content !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

/* Stabilize the expanded row: keep the table scroll usable without the thick
   orange bar visually cutting through the assignment detail UI. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow {
  scrollbar-color: #d8d3ca transparent !important;
  scrollbar-width: thin !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow::-webkit-scrollbar {
  height: 0.5rem !important;
  width: 0.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow::-webkit-scrollbar-track {
  background: transparent !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow::-webkit-scrollbar-thumb {
  background: #d8d3ca !important;
  border-radius: 999rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
  padding: 0.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header {
  margin-bottom: 0.75rem !important;
  min-height: 3rem !important;
  padding: 0.625rem 0.875rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-panel,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-detail-card {
  max-width: 100% !important;
}

/* Keep every assignment column inside the Job Details panel. Values wrap
   within their own cells so the table remains readable without a scrollbar. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow {
  overflow-x: hidden !important;
  overflow-y: visible !important;
  scrollbar-width: none;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow::-webkit-scrollbar {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow > table,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .v-table__overflow table.v-table {
  max-width: 100% !important;
  min-width: 0 !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td {
  box-sizing: border-box !important;
  height: auto !important;
  hyphens: none !important;
  max-width: none !important;
  min-width: 0 !important;
  overflow: visible !important;
  overflow-wrap: normal !important;
  padding: 0.625rem 0.375rem !important;
  text-align: center !important;
  text-overflow: clip !important;
  text-wrap: pretty;
  vertical-align: middle !important;
  white-space: normal !important;
  word-break: normal !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th {
  font-size: 0.625rem !important;
  line-height: 1.25 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td {
  font-size: 0.6875rem !important;
  line-height: 1.35 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(3),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(3),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(9),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(9) {
  min-width: 0 !important;
  width: 6% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(1),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(1),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(2),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(2),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(4),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(4),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(10),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(10) {
  min-width: 0 !important;
  width: 7% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(5),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(5),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(6),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(6),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(7),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(7),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(8),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(8),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(11),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(11),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th:nth-child(12),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(12) {
  min-width: 0 !important;
  width: 10% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td > *,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .layout,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .flex {
  align-items: center !important;
  box-sizing: border-box !important;
  justify-content: center !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: visible !important;
  overflow-wrap: normal !important;
  text-align: center !important;
  text-overflow: clip !important;
  text-wrap: pretty;
  white-space: normal !important;
  word-break: normal !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .layout {
  flex-wrap: wrap !important;
  gap: 0.25rem !important;
  margin: 0 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td:nth-child(6) .pl-3 {
  align-items: center !important;
  padding-left: 0 !important;
  white-space: normal !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .assignments-action-token,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .pay-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .payy-ass-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .track-ass-btn:not(.track-ass-btn--menu),
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .track-assign-btn,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .assignment-document-view-link {
  height: auto !important;
  max-width: 100% !important;
  min-height: 1.75rem !important;
  min-width: 0 !important;
  overflow: visible !important;
  padding: 0.3125rem 0.375rem !important;
  text-overflow: clip !important;
  white-space: normal !important;
  width: auto !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .v-btn__content,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td .assignment-document-view-link span {
  hyphens: none !important;
  max-width: 100% !important;
  overflow: visible !important;
  overflow-wrap: normal !important;
  text-overflow: clip !important;
  text-wrap: pretty;
  white-space: normal !important;
  word-break: normal !important;
}

/* Present the opened assignment as a focused modal without changing its
   existing expansion, data, actions, or close behavior. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
  align-content: center !important;
  background: rgba(18, 24, 38, 0.52) !important;
  backdrop-filter: blur(0.125rem);
  border: 0 !important;
  box-sizing: border-box !important;
  display: grid !important;
  grid-template-columns: minmax(0, 78rem) !important;
  grid-template-rows: auto minmax(0, auto) !important;
  inset: 0 !important;
  justify-content: center !important;
  margin: 0 !important;
  max-height: none !important;
  max-width: none !important;
  overflow: hidden !important;
  padding: 1rem !important;
  position: fixed !important;
  width: auto !important;
  z-index: 50 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header {
  background: var(--oms-primary-soft, #fff7ed) !important;
  border: 0.0625rem solid #f6d9bb !important;
  border-bottom: 0 !important;
  border-radius: 0.75rem 0.75rem 0 0 !important;
  box-shadow: none !important;
  margin: 0 !important;
  min-height: 3.5rem !important;
  padding: 0.75rem 1rem !important;
  position: relative;
  z-index: 1;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header span {
  color: var(--oms-primary-dark, #b45309) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-close {
  background: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > .assignment-detail-panel {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
  box-shadow: 0 1.5rem 4rem rgba(18, 24, 38, 0.24) !important;
  max-height: calc(100vh - 6.5rem) !important;
  min-height: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > .assignment-detail-panel > .assignment-detail-card {
  border: 0 !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
  box-shadow: none !important;
  max-height: calc(100vh - 6.5rem) !important;
  min-height: 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  scrollbar-width: none;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > .assignment-detail-panel > .assignment-detail-card::-webkit-scrollbar {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-detail-body {
  overflow: visible !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-board {
  box-sizing: border-box !important;
  max-height: none !important;
  overflow: visible !important;
  padding: 0.875rem !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-flow,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-track.v-stepper__header {
  height: auto !important;
  max-height: none !important;
  max-width: 100% !important;
  overflow: visible !important;
  width: 100% !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-track.v-stepper__header {
  gap: 0.75rem !important;
  min-height: 0 !important;
  min-width: 0 !important;
  padding: 0 0.25rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card.v-stepper__step {
  flex: 1 1 0 !important;
  height: auto !important;
  max-width: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card .v-stepper__label,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-title,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-meta {
  height: auto !important;
  hyphens: none !important;
  max-width: 100% !important;
  overflow: visible !important;
  overflow-wrap: normal !important;
  text-wrap: pretty;
  white-space: normal !important;
  word-break: normal !important;
}

/* Assignment popup: tighter milestone board, cards and info tiles. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-board {
  padding: 0.625rem 0.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card.v-stepper__step {
  padding-bottom: 0.625rem !important;
  position: relative !important;
}

/* Many milestones: cards keep a readable minimum width and the board
   scrolls sideways; with few milestones they still stretch to fill it. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-board {
  overflow-x: auto !important;
  overflow-y: hidden !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-flow,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-track.v-stepper__header {
  max-width: none !important;
  min-width: 100% !important;
  width: max-content !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card.v-stepper__step {
  flex: 1 0 11.5rem !important;
  max-width: none !important;
  min-width: 11.5rem !important;
}

/* Milestone progress bar: each step draws the connector to the next one.
   Reached = solid green, current -> next = orange fading out, upcoming =
   grey dashes. Circles: green halo when done, pulsing orange when current. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card.v-stepper__step:not(:last-child)::after {
  background: repeating-linear-gradient(
    90deg,
    #d6d2c8 0 0.5rem,
    transparent 0.5rem 0.875rem
  ) !important;
  border-radius: 999rem !important;
  height: 0.25rem !important;
  left: 0.75rem !important;
  top: 0.75rem !important;
  width: calc(100% + 0.75rem) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--done.v-stepper__step:not(:last-child)::after {
  background: #16a66a !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--active.v-stepper__step:not(:last-child)::after {
  background: linear-gradient(90deg, var(--oms-primary, #ea7a1c), #d6d2c8 70%) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card.v-stepper__step .v-stepper__step__step {
  background: #ffffff !important;
  border: 0.125rem solid #d6d2c8 !important;
  color: var(--oms-muted, #74716a) !important;
  font-family: inherit !important;
  font-weight: 800 !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--done.v-stepper__step .v-stepper__step__step {
  background: #16a66a !important;
  border-color: #16a66a !important;
  box-shadow: 0 0 0 0.25rem rgba(22, 166, 106, 0.16) !important;
  color: #ffffff !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--done.v-stepper__step .v-stepper__step__step .v-icon {
  color: #ffffff !important;
  font-size: 0.875rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--active.v-stepper__step .v-stepper__step__step {
  animation: assignment-step-pulse 1.8s ease-out infinite;
  background: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

@keyframes assignment-step-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(234, 122, 28, 0.45);
  }
  70% {
    box-shadow: 0 0 0 0.4375rem rgba(234, 122, 28, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(234, 122, 28, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card--active.v-stepper__step .v-stepper__step__step {
    animation: none;
    box-shadow: 0 0 0 0.25rem rgba(234, 122, 28, 0.2) !important;
  }
}

/* Milestone card: badge + actions row, title, then labelled details. */
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-card__top {
  align-items: center !important;
  display: flex !important;
  gap: 0.5rem;
  justify-content: space-between !important;
  min-height: 1.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-actions {
  align-items: center;
  display: inline-flex;
  gap: 0.375rem;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-actions > span {
  display: inline-flex;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-comment.viewDetail,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-reverse {
  align-items: center !important;
  border-radius: 999rem !important;
  display: inline-flex !important;
  font-size: 0.9375rem !important;
  height: 1.75rem !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 !important;
  position: static !important;
  transition: background-color 0.16s ease;
  width: 1.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-comment.viewDetail {
  background: var(--oms-blue-soft, #eaf1fd) !important;
  color: var(--oms-blue, #2456b8) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-comment.viewDetail:hover {
  background: var(--oms-blue-border, #d3e1fb) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-reverse {
  background: var(--oms-red-soft, #fbeae8) !important;
  color: var(--oms-red, #be3b32) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-reverse:hover {
  background: var(--oms-red-border, #f0cfcc) !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-title {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.875rem !important;
  font-weight: 800 !important;
  line-height: 1.3 !important;
  margin-top: 0.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-hint {
  margin-top: 0.25rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-details {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.625rem;
  padding-top: 0.625rem;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-details:empty {
  display: none;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-detail {
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  min-width: 0;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-detail__label {
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1.35;
  text-transform: uppercase;
  white-space: nowrap;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-milestone-detail__value {
  color: var(--oms-ink, #3a382f);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-detail-panel .layout.row.py-4 {
  gap: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-detail-panel .layout.row.py-4 > .flex,
.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-detail-panel .layout.row.py-4 > div > .flex {
  min-height: 0 !important;
  padding: 0.5rem 0.75rem !important;
}

.job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell .assignment-detail-panel .layout.row.py-4 .subheading.muted {
  margin-bottom: 0.125rem !important;
}

@media (max-width: 64rem) {
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table th {
    font-size: 0.5625rem !important;
    padding-left: 0.1875rem !important;
    padding-right: 0.1875rem !important;
  }

  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table table tbody tr.assignment-row > td {
    font-size: 0.625rem !important;
    padding-left: 0.1875rem !important;
    padding-right: 0.1875rem !important;
  }
}

@media (max-width: 48rem) {
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell {
    align-content: stretch !important;
    padding: 0.5rem !important;
  }

  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-header {
    min-height: 3.25rem !important;
    padding: 0.625rem 0.75rem !important;
  }

  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > .assignment-detail-panel,
  .job-dossier--modern .jd-assignments-panel .assignments-modern-card #dataTable.assignments-modern-table .assignment-focus-shell > .assignment-detail-panel > .assignment-detail-card {
    max-height: calc(100vh - 4.25rem) !important;
  }
}
</style>
